export const  gluky_addressfield_mx_states_list = () => {
    let temporalStates = [];
  const states = {
    'AG' : "Aguascalientes",
    "BC" : "Baja California",
    "BS" : "Baja California Sur",
    "CM" : "Campeche",
    "CS" : "Chiapas",
    "CH" : "Chihuahua",
    "DF" : "Ciudad de México",
    "CO" : "Coahuila",
    "CL" : "Colima",
    "DG" : "Durango",
    "MX" : "Estado de México",
    "GT" : "Guanajuato",
    "GR" : "Guerrero",
    "HG" : "Hidalgo",
    "JA" : "Jalisco",
    "MI" : "Michoacán",
    "MO" : "Morelos",
    "NA" : "Nayarit",
    "NL" : "Nuevo León",
    "OA" : "Oaxaca",
    "PU" : "Puebla",
    "QT" : "Querétaro",
    "QR" : "Quintana Roo",
    "SL" : "San Luis Potosí",
    "SI" : "Sinaloa",
    "SO" : "Sonora",
    "TB" : "Tabasco",
    "TM" : "Tamaulipas",
    "TL" : "Tlaxcala",
    "VE" : "Veracruz",
    "YU" : "Yucatán",
    "ZA" : "Zacatecas",
  };
    Object.keys(states).map((res) => {
        temporalStates = [
            ...temporalStates,
            {
                name: states[res],
                code: res,
            },
        ];
    });
    return temporalStates;
    
}

export function gluky_addressfield_mx_cities_list($state_code) {
    let temporalCities = [];
  const $data =  {
    "AG" : {
      "20000" : "AGUASCALIENTES", 
      "20700" : "ASIENTOS", 
      "20800" : "CALVILLO", 
      "20460" : "COSIO", 
      "20330" : "EL LLANO", 
      "20900" : "JESUS MARIA", 
      "20663" : "PABELLON DE ARTEAGA", 
      "20400" : "RINCON DE ROMOS", 
      "20300" : "SAN FRANCISCO DE LOS ROMO", 
      "20500" : "SAN JOSE DE GRACIA", 
      "20600" : "TEPEZALA", 
    }, 
    "BC" : {
      "22750" : "ENSENADA", 
      "21000" : "MEXICALI", 
      "22700" : "PLAYAS DE ROSARITO", 
      "21700" : "ROSARITO", 
      "22930" : "SAN QUINTIN", 
      "21400" : "TECATE", 
      "22000" : "TIJUANA", 
    }, 
    "BS" : {
      "23410" : "CABO SAN LUCAS", 
      "23600" : "COMONDU", 
      "23000" : "LA PAZ", 
      "23400" : "LOS CABOS", 
      "23900" : "MULEGE", 
}, 
    "CS" : {
      "30590" : "ACACOYAGUA", 
      "29370" : "ACALA", 
      "30580" : "ACAPETAHUA", 
      "30190" : "ALTAMIRANO", 
      "29700" : "AMATAN", 
      "30930" : "AMATENANGO DE LA FRONTERA", 
      "29430" : "AMATENANGO DEL VALLE", 
      "30370" : "ANGEL ALBINO CORZO", 
      "30450" : "ARRIAGA", 
      "30950" : "BEJUCAL DE OCAMPO", 
      "30130" : "BELLA VISTA", 
      "29130" : "BERRIOZABAL", 
      "29770" : "BOCHIL", 
      "30890" : "CACAHOATAN", 
      "29980" : "CATAZAJA", 
      "29850" : "CHALCHIHUITAN", 
      "29320" : "CHAMULA", 
      "29440" : "CHANAL", 
      "29690" : "CHAPULTENANGO", 
      "29870" : "CHENALHO", 
      "29160" : "CHIAPA DE CORZO", 
      "29390" : "CHIAPILLA", 
      "29640" : "CHICOASEN", 
      "30120" : "CHICOMUSELO", 
      "29940" : "CHILON", 
      "30400" : "CINTALAPA", 
      "29650" : "COAPILLA", 
      "30000" : "COMITAN DE DOMINGUEZ", 
      "29620" : "COPAINALA", 
      "29840" : "EL BOSQUE", 
      "30970" : "EL PORVENIR", 
      "30600" : "ESCUINTLA", 
      "29560" : "FRANCISCO LEON", 
      "30140" : "FRONTERA COMALAPA", 
      "30850" : "FRONTERA HIDALGO", 
      "30660" : "HUEHUETAN", 
      "29710" : "HUITIUPAN", 
      "29470" : "HUIXTAN", 
      "30640" : "HUIXTLA", 
      "29720" : "IXHUATAN", 
      "29570" : "IXTACOMITAN", 
      "29340" : "IXTAPA", 
      "29590" : "IXTAPANGAJOYA", 
      "30430" : "JIQUIPILAS", 
      "29760" : "JITOTOL", 
      "29510" : "JUAREZ", 
      "30360" : "LA CONCORDIA", 
      "30960" : "LA GRANDEZA", 
      "30170" : "LA INDEPENDENCIA", 
      "29970" : "LA LIBERTAD", 
      "30160" : "LA TRINITARIA", 
      "29860" : "LARRAINZAR", 
      "30180" : "LAS MARGARITAS", 
      "30350" : "LAS ROSAS", 
      "30560" : "MAPASTEPEC", 
      "30920" : "MAZAPA DE MADERO", 
      "30650" : "MAZATAN", 
      "30860" : "METAPA", 
      "29490" : "MITONTIC", 
      "30900" : "MOTOZINTLA", 
      "30340" : "NICOLAS RUIZ", 
      "29950" : "OCOSINGO", 
      "29680" : "OCOTEPEC", 
      "29140" : "OCOZOCOAUTLA DE ESPINOSA", 
      "29550" : "OSTUACAN", 
      "29190" : "OSUMACINTA", 
      "29450" : "OXCHUC", 
      "29960" : "PALENQUE", 
      "29880" : "PANTELHO", 
      "29660" : "PANTEPEC", 
      "29520" : "PICHUCALCO", 
      "30540" : "PIJIJIAPAN", 
      "29750" : "PUEBLO NUEVO SOLISTAHUACAN", 
      "29740" : "RAYON", 
      "29500" : "REFORMA", 
      "29800" : "SABANILLA", 
      "29900" : "SALTO DE AGUA", 
      "29200" : "SAN CRISTOBAL DE LAS CASAS", 
      "29120" : "SAN FERNANDO", 
      "29790" : "SAN JUAN CANCUC", 
      "29400" : "SAN LUCAS", 
      "30980" : "SILTEPEC", 
      "29820" : "SIMOJOVEL", 
      "29890" : "SITALA", 
      "30390" : "SOCOLTENANGO", 
      "29580" : "SOLOSUCHIAPA", 
      "29780" : "SOYALO", 
      "29150" : "SUCHIAPA", 
      "30840" : "SUCHIATE", 
      "29540" : "SUNUAPA", 
      "30700" : "TAPACHULA", 
      "29670" : "TAPALAPA", 
      "29730" : "TAPILULA", 
      "29600" : "TECPATAN", 
      "29480" : "TENEJAPA", 
      "29410" : "TEOPISCA", 
      "29910" : "TILA", 
      "30500" : "TONALA", 
      "30330" : "TOTOLAPA", 
      "29920" : "TUMBALA", 
      "30867" : "TUXTLA CHICO", 
      "29000" : "TUXTLA GUTIERREZ", 
      "30680" : "TUZANTAN", 
      "30110" : "TZIMOL", 
      "30880" : "UNION JUAREZ", 
      "30200" : "VENUSTIANO CARRANZA", 
      "30620" : "VILLA COMALTITLAN", 
      "30520" : "VILLA CORZO", 
      "30470" : "VILLAFLORES", 
      "29930" : "YAJALON", 
      "29350" : "ZINACANTAN", 
    }, 
    "CH" : {
      "32800" : "AHUMADA", 
      "32900" : "ALDAMA", 
      "33920" : "ALLENDE", 
      "31650" : "AQUILES SERDAN", 
      "31820" : "ASCENSION", 
      "31660" : "BACHINIVA", 
      "33560" : "BALLEZA", 
      "33400" : "BATOPILAS", 
      "33200" : "BOCOYNA", 
      "31880" : "BUENAVENTURA", 
      "33600" : "CAMARGO", 
      "33280" : "CARICHI", 
      "31850" : "CASAS GRANDES", 
      "31000" : "CHIHUAHUA", 
      "33360" : "CHINIPAS", 
      "33990" : "CORONADO", 
      "32850" : "COYAME", 
      "31500" : "CUAUHTEMOC", 
      "33240" : "CUSIHUIRIACHI", 
      "33000" : "DELICIAS", 
      "33140" : "DOCTOR BELISARIO DOMINGUEZ", 
      "33550" : "EL TULE", 
      "31870" : "GALEANA", 
      "33270" : "GENERAL TRIAS", 
      "31900" : "GOMEZ FARIAS", 
      "33260" : "GRAN MORELOS", 
      "33180" : "GUACHOCHI", 
      "32740" : "GUADALUPE", 
      "33470" : "GUADALUPE Y CALVO", 
      "33380" : "GUAZAPARES", 
      "31680" : "GUERRERO", 
      "33800" : "HIDALGO DEL PARRAL", 
      "33540" : "HUEJOTITAN", 
      "31920" : "IGNACIO ZARAGOZA", 
      "31840" : "JANOS", 
      "33980" : "JIMENEZ", 
      "32000" : "JUAREZ", 
      "32950" : "JULIMES", 
      "33670" : "LA CRUZ", 
      "33940" : "LOPEZ", 
      "31940" : "MADERA", 
      "33370" : "MAGUARICHI", 
      "32980" : "MANUEL BENAVIDES", 
      "31990" : "MATACHI", 
      "33960" : "MATAMOROS", 
      "33130" : "MEOQUI", 
      "33450" : "MORELOS", 
      "33340" : "MORIS", 
      "31960" : "NAMIQUIPA", 
      "33170" : "NONOAVA", 
      "31700" : "NUEVO CASAS GRANDES", 
      "33320" : "OCAMPO", 
      "32880" : "OJINAGA", 
      "32780" : "PRAXEDIS G GUERRERO", 
      "31640" : "RIVA PALACIO", 
      "33120" : "ROSALES", 
      "33530" : "ROSARIO", 
      "33160" : "SAN FRANCISCO DE BORJA", 
      "33680" : "SAN FRANCISCO DE CONCHOS", 
      "33500" : "SAN FRANCISCO DEL ORO", 
      "33580" : "SANTA BARBARA", 
      "33150" : "SATEVO", 
      "33620" : "SAUCILLO", 
      "31980" : "TEMOSACHI", 
      "33420" : "URIQUE", 
      "33300" : "URUACHI", 
      "33650" : "VALLE DE ZARAGOZA", 
    }, 
    "CL" : {
      "28300" : "ARMERIA", 
      "28000" : "COLIMA", 
      "28450" : "COMALA", 
      "28400" : "COQUIMATLAN", 
      "28500" : "CUAUHTEMOC", 
      "28700" : "IXTLAHUACAN", 
      "28200" : "MANZANILLO", 
      "28750" : "MINATITLAN", 
      "28100" : "TECOMAN", 
      "28950" : "VILLA DE ALVAREZ", 
    }, 
    "CM" : {
      "24900" : "CALKINI", 
      "24000" : "CAMPECHE", 
      "24100" : "CARMEN", 
      "24400" : "CHAMPOTON", 
      "24350" : "ESCARCEGA", 
      "24800" : "HECELCHAKAN", 
      "24600" : "HOPELCHEN", 
      "24200" : "PALIZADA", 
      "24700" : "TENABO", 
    }, 
    "CO" : {
      "25540" : "ABASOLO", 
      "26200" : "ACUNA", 
      "26530" : "ALLENDE", 
      "25350" : "ARTEAGA", 
      "25570" : "CANDELA", 
      "25870" : "CASTANOS", 
      "27640" : "CUATROCIENEGAS", 
      "25470" : "ESCOBEDO", 
      "27900" : "FRANCISCO I MADERO", 
      "25600" : "FRONTERA", 
      "25950" : "GENERAL CEPEDA", 
      "26640" : "GUERRERO", 
      "26670" : "HIDALGO", 
      "26400" : "JIMENEZ", 
      "25400" : "JUAREZ", 
      "27700" : "LAMADRID", 
      "27440" : "MATAMOROS", 
      "25830" : "MONCIOVA", 
      "25700" : "MONCLOVA", 
      "26500" : "MORELOS", 
      "26340" : "MUZQUIZ", 
      "27550" : "NADADORES", 
      "26170" : "NAVA", 
      "27500" : "OCAMPO", 
      "27980" : "PARRAS", 
      "26000" : "PIEDRAS NEGRAS", 
      "25420" : "PROGRESO", 
      "25900" : "RAMOS ARIZPE", 
      "26700" : "SABINAS", 
      "27750" : "SACRAMENTO", 
      "25000" : "SALTILLO", 
      "25500" : "SAN BUENAVENTURA", 
      "26800" : "SAN JUAN DE SABINAS", 
      "27800" : "SAN PEDRO", 
      "27600" : "SIERRA MOJADA", 
      "27000" : "TORREON", 
      "27480" : "VIESCA", 
      "26600" : "VILLA UNION", 
      "26450" : "ZARAGOZA", 
    }, 
    "DF" : {
      "01000" : "ALVARO OBREGON", 
      "02000" : "AZCAPOTZALCO", 
      "03000" : "BENITO JUAREZ", 
      "04000" : "COYOACAN", 
      "05000" : "CUAJIMALPA DE MORELOS", 
      "06000" : "CUAUHTEMOC", 
      "07000" : "GUSTAVO A MADERO", 
      "08000" : "IZTACALCO", 
      "09000" : "IZTAPALAPA", 
      "10000" : "LA MAGDALENA CONTRERAS", 
      "11000" : "MIGUEL HIDALGO", 
      "12000" : "MILPA ALTA", 
      "13000" : "TLAHUAC", 
      "14000" : "TLALPAN", 
      "15000" : "VENUSTIANO CARRANZA", 
      "16000" : "XOCHIMILCO", 
    }, 
    "DG" : {
      "34400" : "CANATLAN", 
      "34500" : "CANELAS", 
      "34470" : "CONETO DE COMONFORT", 
      "35800" : "CUENCAME", 
      "34000" : "DURANGO", 
      "35650" : "EL ORO", 
      "35950" : "GENERAL SIMON BOLIVAR", 
      "35000" : "GOMEZ PALACIO", 
      "34700" : "GUADALUPE VICTORIA", 
      "35400" : "GUANACEVI", 
      "35300" : "HIDALGO", 
      "35500" : "INDE", 
      "35150" : "LERDO", 
      "35200" : "MAPIMI", 
      "34970" : "MEZQUITAL", 
      "35700" : "NAZAS", 
      "34840" : "NOMBRE DE DIOS", 
      "34410" : "NUEVO IDEAL", 
      "35350" : "OCAMPO", 
      "34650" : "OTAEZ", 
      "34770" : "PANUCO DE CORONADO", 
      "34740" : "PENON BLANCO", 
      "34800" : "POANAS", 
      "34940" : "PUEBLO NUEVO", 
      "35760" : "RODEO", 
      "35450" : "SAN BERNARDO", 
      "34670" : "SAN DIMAS", 
      "35900" : "SAN JUAN DE GUADALUPE", 
      "34480" : "SAN JUAN DEL RIO", 
      "35740" : "SAN LUIS DEL CORDERO", 
      "35550" : "SAN PEDRO DEL GALLO", 
      "35880" : "SANTA CIARA", 
      "34600" : "SANTIAGO PAPASQUIARO", 
      "34900" : "SUCHIL", 
      "34570" : "TAMAZULA", 
      "35600" : "TEPEHUANES", 
      "35270" : "TLAHUALILO", 
      "34540" : "TOPIA", 
      "34890" : "VICENTE GUERRERO", 
    }, 
    "MX" : {
      "50300" : "ACAMBAY", 
      "55870" : "ACOLMAN", 
      "50360" : "ACULCO", 
      "51860" : "ALMOLOYA DE ALQUISIRAS", 
      "50900" : "ALMOLOYA DE JUAREZ", 
      "52540" : "ALMOLOYA DEL RIO", 
      "51260" : "AMANALCO", 
      "51500" : "AMATEPEC", 
      "56900" : "AMECAMECA", 
      "55660" : "APAXCO", 
      "56300" : "ATENCO", 
      "52500" : "ATIZAPAN", 
      "52900" : "ATIZAPAN DE ZARAGOZA", 
      "50450" : "ATLACOMULCO", 
      "56970" : "ATLAUTLA", 
      "55940" : "AXAPUSCO", 
      "56760" : "AYAPANGO", 
      "52200" : "CALIMAYA", 
      "52700" : "CAPULHUAC", 
      "56600" : "CHALCO", 
      "54350" : "CHAPA DE MOTA", 
      "52240" : "CHAPULTEPEC", 
      "56030" : "CHIAUTLA", 
      "56370" : "CHICOLOAPAN", 
      "56270" : "CHICONCUAC", 
      "56330" : "CHIMALHUACAN", 
      "55700" : "COACALCO", 
      "51700" : "COATEPEC HARINAS", 
      "56680" : "COCOTITLAN", 
      "54660" : "COYOTEPEC", 
      "54800" : "CUAUTITLAN", 
      "54700" : "CUAUTITLAN IZCALLI", 
      "51030" : "DONATO GUERRA", 
      "55000" : "ECATEPEC", 
      "56990" : "ECATZINGO", 
      "50600" : "EL ORO", 
      "54680" : "HUEHUETOCA", 
      "55670" : "HUEYPOXTLA", 
      "52760" : "HUIXQUILUCAN", 
      "54480" : "ISIDRO FABELA", 
      "56530" : "IXTAPALUCA", 
      "51900" : "IXTAPAN DE LA SAL", 
      "51070" : "IXTAPAN DEL ORO", 
      "50740" : "IXTLAHUACA", 
      "52680" : "JALATLACO", 
      "55780" : "JALTENCO", 
      "54240" : "JILOTEPEC", 
      "54570" : "JILOTZINGO", 
      "50800" : "JIQUIPILCO", 
      "50700" : "JOCOTITLAN", 
      "52370" : "JOQUICINGO", 
      "56860" : "JUCHITEPEC", 
      "56400" : "LA PAZ", 
      "52000" : "LERMA", 
      "52440" : "MALINALCO", 
      "54880" : "MELCHOR OCAMPO", 
      "52140" : "METEPEC", 
      "52180" : "MEXICALTZINGO", 
      "50550" : "MORELOS", 
      "53000" : "NAUCALPAN", 
      "55790" : "NEXTLALPAN", 
      "57000" : "NEZAHUALCOYOTL", 
      "54400" : "NICOLAS ROMERO", 
      "55970" : "NOPALTEPEC", 
      "52740" : "OCOYOACAC", 
      "52480" : "OCUILAN", 
      "55900" : "OTUMBA", 
      "51130" : "OTZOLOAPAN", 
      "52080" : "OTZOLOTEPEC", 
      "56800" : "OZUMBA", 
      "56050" : "PAPALOTLA", 
      "54200" : "POLOTITLAN", 
      "52360" : "RAYON", 
      "52280" : "SAN ANTONIO LA ISLA", 
      "50640" : "SAN FELIPE DEL PROGRESO", 
      "55850" : "SAN MARTIN DE LAS PIRAMIDES", 
      "52100" : "SAN MATEO ATENCO", 
      "51470" : "SAN SIMON DE GUERRERO", 
      "51100" : "SANTO TOMAS", 
      "54280" : "SOYANIQUILPAN DE JUAREZ", 
      "51600" : "SULTEPEC", 
      "55740" : "TECAMAC", 
      "51400" : "TEJUPILCO", 
      "56650" : "TEMAMATLA", 
      "55980" : "TEMASCALAPA", 
      "50400" : "TEMASCALCINGO", 
      "51300" : "TEMASCALTEPEC", 
      "50850" : "TEMOAYA", 
      "52400" : "TENANCINGO", 
      "56780" : "TENANGO DEL AIRE", 
      "52300" : "TENANGO DEL VALLE", 
      "54770" : "TEOLOYUCAN", 
      "55800" : "TEOTIHUACAN", 
      "56070" : "TEPETLAOXTOC", 
      "56880" : "TEPETLIXPA", 
      "54600" : "TEPOTZOTLAN", 
      "55650" : "TEQUIXQUIAC", 
      "51670" : "TEXCALTITLAN", 
      "52570" : "TEXCALYACAC", 
      "56100" : "TEXCOCO", 
      "56000" : "TEZOYUCA", 
      "52600" : "TIANGUISTENCO", 
      "50500" : "TIMILPAN", 
      "56700" : "TLALMANALCO", 
      "54000" : "TLALNEPANTLA", 
      "51550" : "TLATLAYA", 
      "50000" : "TOLUCA", 
      "51950" : "TONATICO", 
      "54960" : "TULTEPEC", 
      "54900" : "TULTITLAN", 
      "51200" : "VALLE DE BRAVO", 
      "56610" : "VALLE DE CHALCO SOLIDARIDAD", 
      "51000" : "VILLA DE ALLENDE", 
      "54300" : "VILLA DEL CARBON", 
      "51760" : "VILLA GUERRERO", 
      "50960" : "VILLA VICTORIA", 
      "52060" : "XONACATLAN", 
      "51160" : "ZACAZONAPAN", 
      "51800" : "ZACUALPAN", 
      "51350" : "ZINACANTEPEC", 
      "51980" : "ZUMPAHUACAN", 
      "55600" : "ZUMPANGO", 
    }, 
    "GT" : {
      "36970" : "ABASOLO", 
      "38600" : "ACAMBARO", 
      "37700" : "ALLENDE", 
      "38500" : "APASEO EL ALTO", 
      "38160" : "APASEO EL GRANDE", 
      "37940" : "ATARJEA", 
      "38000" : "CELAYA", 
      "38200" : "COMONFORT", 
      "38590" : "CORONEO", 
      "38300" : "CORTAZAR", 
      "36960" : "CUERAMARO", 
      "37960" : "DOCTOR MORA", 
      "37800" : "DOLORES HIDALGO", 
      "36000" : "GUANAJUATO", 
      "36990" : "HUANIMARO", 
      "36500" : "IRAPUATO", 
      "38470" : "JARAL DEL PROGRESO", 
      "38540" : "JERECUARO", 
      "37000" : "LEON", 
      "36470" : "MANUEL DOBLADO", 
      "38800" : "MOROLEON", 
      "37630" : "OCAMPO", 
      "36900" : "PENJAMO", 
      "36890" : "PUEBLO NUEVO", 
      "36400" : "PURISIMA DEL RINCON", 
      "36200" : "ROMITA", 
      "36700" : "SALAMANCA", 
      "38900" : "SALVATIERRA", 
      "37850" : "SAN DIEGO DE LA UNION", 
      "37600" : "SAN FELIPE", 
      "36300" : "SAN FRANCISCO DEL RINCON", 
      "37980" : "SAN JOSE ITURBIDE", 
      "37900" : "SAN LUIS DE LA PAZ", 
      "37950" : "SANTA CATARINA", 
      "38240" : "SANTA CRUZ DE JUVENTINO ROSAS", 
      "38970" : "SANTIAGO MARAVATIO", 
      "36100" : "SILAO", 
      "38790" : "TARANDACUAO", 
      "38700" : "TARIMORO", 
      "37970" : "TIERRA BLANCA", 
      "38980" : "URIANGATO", 
      "38400" : "VALLE DE SANTIAGO", 
      "37920" : "VICTORIA", 
      "38260" : "VILLAGRAN", 
      "37930" : "XICHU", 
      "38940" : "YURIRIA", 
    },
    "GR": {
      "39300" : "ACAPULCO DE JUAREZ", 
      "41130" : "AHUACUOTZINGO", 
      "40730" : "AJUCHITLAN DEL PROGRESO", 
      "41670" : "ALCOZAUCA DE GUERRERO", 
      "41270" : "ALPOYECA", 
      "40531" : "APAXTLA", 
      "40500" : "ARCELIA", 
      "41030" : "ATENANGO DEL RIO", 
      "41570" : "ATLAMAJALCINGO DEL MONTE", 
      "41440" : "ATLIXTAC", 
      "40930" : "ATOYAC DE ALVAREZ", 
      "39200" : "AYUTLA DE LOS LIBRES", 
      "41900" : "AZOYU", 
      "40960" : "BENITO JUAREZ", 
      "40330" : "BUENAVISTA DE CUELLAR", 
      "41100" : "CHILAPA DE ALVAREZ", 
      "39000" : "CHILPANCINGO DE LOS BRAVO", 
      "40860" : "COAHUAYUTLA DE JOSE MARIA IZAZ", 
      "40580" : "COCULA", 
      "41870" : "COPALA", 
      "41060" : "COPALILLO", 
      "41470" : "COPANATOYAC", 
      "40970" : "COYUCA DE BENITEZ", 
      "40700" : "COYUCA DE CATALAN", 
      "41640" : "CUAJINICUILAPA", 
      "41080" : "CUALAC", 
      "41840" : "CUAUTEPEC", 
      "40560" : "CUETZALA DEL PROGRESO", 
      "40630" : "CUTZAMALA DE PINZON", 
      "40180" : "EDUARDO NERI", 
      "41800" : "FLORENCIO VILLARREAL", 
      "40480" : "GENERAL CANUTO A NERI", 
      "39130" : "GENERAL HELIODORO CASTILLO", 
      "41200" : "HUAMUXTITLAN", 
      "40130" : "HUITZUCO DE LOS FIGUEROA", 
      "40000" : "IGUALA DE LA INDEPENDENCIA", 
      "41970" : "IGUALAPA", 
      "40430" : "IXCATEOPAN DE CUAUHTEMOC", 
      "40880" : "JOSE AZUETA", 
      "39940" : "JUAN R ESCUDERO", 
      "40800" : "LA UNION", 
      "39150" : "LEONARDO BRAVO", 
      "41500" : "MALINALTEPEC", 
      "41180" : "MARTIR DE CUILAPAN", 
      "41641" : "METLATONOC", 
      "39230" : "MOCHITLAN", 
      "41000" : "OLINALA", 
      "41700" : "OMETEPEC", 
      "40460" : "PEDRO ASCENCIO ALQUISIRAS", 
      "40830" : "PETATLAN", 
      "40380" : "PILCAYA", 
      "40660" : "PUNGARABATO", 
      "39250" : "QUECHULTENANGO", 
      "41600" : "SAN LUIS ACATLAN", 
      "39960" : "SAN MARCOS", 
      "40780" : "SAN MIGUEL TOTOLAPAN", 
      "40200" : "TAXCO DE ALARCON", 
      "39270" : "TECOANAPA", 
      "40900" : "TECPAN DE GALEANA", 
      "40400" : "TELOLOAPAN", 
      "40160" : "TEPECOACUILCO DE TRUJANO", 
      "40360" : "TETIPAC", 
      "39170" : "TIXTLA DE GUERRERO", 
      "41740" : "TLACOACHISTLAHUACA", 
      "41540" : "TLACOAPA", 
      "40680" : "TLALCHAPA", 
      "41350" : "TLALIXTAQUILLA DE MALDONADO", 
      "41300" : "TLAPA DE COMONFORT", 
      "40600" : "TLAPEHUALA", 
      "41380" : "XALPATLAHUAC", 
      "41240" : "XOCHIHUEHUETLAN", 
      "41770" : "XOCHISTLAHUACA", 
      "41400" : "ZAPOTITLAN TABLAS", 
      "40760" : "ZIRANDARO", 
      "41160" : "ZITLALA", 
    }, 
    "HG" : {
      "43540" : "ACATLAN", 
      "43720" : "ACAXOCHITLAN", 
      "42500" : "ACTOPAN", 
      "43460" : "AGUA BLANCA DE ITURBIDE", 
      "42150" : "AJACUBA", 
      "42390" : "ALFAJAYUCAN", 
      "43940" : "ALMOLOYA", 
      "43900" : "APAN", 
      "42970" : "ATITALAQUIA", 
      "43060" : "ATLAPEXCO", 
      "42980" : "ATOTONILCO DE TULA", 
      "43300" : "ATOTONILCO EL GRANDE", 
      "43230" : "CALNALI", 
      "42370" : "CARDONAL", 
      "42900" : "CHAPANTONGO", 
      "42280" : "CHAPULHUACAN", 
      "42750" : "CHILCUAUTLA", 
      "43740" : "CUAUTEPEC DE HINOJOSA", 
      "42680" : "EL ARENAL", 
      "43330" : "ELOXOCHITLAN", 
      "43960" : "EMILIANO ZAPATA", 
      "43580" : "EPAZOYUCAN", 
      "42660" : "FRANCISCO I MADERO", 
      "43500" : "HUASCA DE OCAMPO", 
      "43050" : "HUAUTLA", 
      "43070" : "HUAZALINGO", 
      "43420" : "HUEHUETLA", 
      "43000" : "HUEJUTLA DE REYES", 
      "42400" : "HUICHAPAN", 
      "42300" : "IXMIQUILPAN", 
      "42200" : "JACALA DE LEDEZMA", 
      "43040" : "JALTOCAN", 
      "43190" : "JUAREZ HIDALGO", 
      "42260" : "LA MISION", 
      "43140" : "LOLOTLA", 
      "43400" : "METEPEC", 
      "43350" : "METZTITLAN", 
      "42180" : "MINERAL DE LA REFORMA", 
      "42120" : "MINERAL DEL CHICO", 
      "42130" : "MINERAL DEL MONTE", 
      "42700" : "MIXQUIAHUALA DE JUAREZ", 
      "43100" : "MOLANGO DE ESCAMILLA", 
      "42360" : "NICOLAS FLORES", 
      "42470" : "NOPALA DE VILLAGRAN", 
      "43560" : "OMITLAN DE JUAREZ", 
      "42000" : "PACHUCA DE SOTO", 
      "42240" : "PACULA", 
      "42220" : "PISAFLORES", 
      "42730" : "PROGRESO DE OBREGON", 
      "43380" : "SAN AGUSTIN METZQUITITLAN", 
      "42160" : "SAN AGUSTIN TLAXIACA", 
      "43440" : "SAN BARTOLO TUTOTEPEC", 
      "43020" : "SAN FELIPE ORIZATLAN", 
      "42640" : "SAN SALVADOR", 
      "42620" : "SANTIAGO DE ANAYA", 
      "43760" : "SANTIAGO TULANTEPEC DE LUGO GU", 
      "43780" : "SINGUILUCAN", 
      "42380" : "TASQUILLO", 
      "42440" : "TECOZAUTLA", 
      "43480" : "TENANGO DE DORIA", 
      "43970" : "TEPEAPULCO", 
      "43120" : "TEPEHUACAN DE GUERRERO", 
      "42850" : "TEPEJI DEL RIO DE OCAMPO", 
      "42920" : "TEPETITLAN", 
      "42940" : "TETEPANGO", 
      "42760" : "TEZONTEPEC DE ALDAMA", 
      "43270" : "TIANGUISTENGO", 
      "43800" : "TIZAYUCA", 
      "42780" : "TLAHUELILPAN", 
      "43170" : "TLAHUILTEPA", 
      "43930" : "TLANALAPA", 
      "43150" : "TLANCHINOL", 
      "42950" : "TLAXCOAPAN", 
      "43860" : "TOLCAYUCA", 
      "42800" : "TULA DE ALLENDE", 
      "43600" : "TULANCINGO DE BRAVO", 
      "43880" : "VILLA DE TEZONTEPEC", 
      "43090" : "XOCHIATIPAN", 
      "43250" : "XOCHICOATLAN", 
      "43080" : "YAHUALICA", 
      "43200" : "ZACUALTIPAN DE ANGELES", 
      "42190" : "ZAPOTLAN DE JUAREZ", 
      "43830" : "ZEMPOALA", 
      "42330" : "ZIMAPAN", 
    }, 
    "JA" : {
      "45470" : "ACATIC", 
      "45700" : "ACATLAN DE JUAREZ", 
      "46730" : "AHUALULCO DE MERCADO", 
      "49370" : "AMACUECA", 
      "45380" : "AMATITAN", 
      "46600" : "AMECA", 
      "46560" : "ANTONIO ESCOBEDO", 
      "47180" : "ARANDAS", 
      "45350" : "ARENAL", 
      "45790" : "ATEMAJAC DE BRIZUELA", 
      "48160" : "ATENGO", 
      "48100" : "ATENGUILLO", 
      "47750" : "ATOTONILCO EL ALTO", 
      "49200" : "ATOYAC", 
      "48900" : "AUTLAN DE NAVARRO", 
      "47930" : "AYOTLAN", 
      "48050" : "AYUTLA", 
      "46130" : "BOLANOS", 
      "48400" : "CABO CORRIENTES", 
      "47360" : "CANADAS DE OBREGON", 
      "48930" : "CASIMIRO CASTILLO", 
      "45900" : "CHAPALA", 
      "46300" : "CHIMALTITAN", 
      "48640" : "CHIQUILISTLAN", 
      "48970" : "CIHUATLAN", 
      "49000" : "CIUDAD GUZMAN", 
      "49700" : "CIUDAD VENUSTIANO CARRANZA", 
      "48500" : "COCULA", 
      "46200" : "COLOTLAN", 
      "49170" : "CONCEPCION DE BUENOS AIRES", 
      "48950" : "CUAUTITLAN", 
      "48150" : "CUAUTLA", 
      "45480" : "CUQUIO", 
      "47980" : "DEGOLLADO", 
      "48670" : "EJUTLA", 
      "48740" : "EL GRULLO", 
      "48700" : "EL LIMON", 
      "45680" : "EL SALTO", 
      "47270" : "ENCARNACION DE DIAZ", 
      "46500" : "ETZATLAN", 
      "49120" : "GOMEZ FARIAS", 
      "46800" : "GUACHINANGO", 
      "44008" : "GUADALAJARA", 
      "46440" : "HOSTOTIPAQUILLO", 
      "46260" : "HUEJUCAR", 
      "46000" : "HUEJUQUILLA EL ALTO", 
      "45850" : "IXTLAHUACAN DE LOS MEMBRILLOS", 
      "45260" : "IXTLAHUACAN DEL RIO", 
      "47120" : "JALOSTOTITLAN", 
      "47900" : "JAMAY", 
      "47950" : "JESUS MARIA", 
      "49950" : "JILOTLAN DE LOS DOLORES", 
      "45800" : "JOCOTEPEC", 
      "45880" : "JUANACATLAN", 
      "48600" : "JUCHITLAN", 
      "47910" : "LA BARCA", 
      "48850" : "LA HUERTA", 
      "47400" : "LAGOS DE MORENO", 
      "46470" : "MAGDALENA", 
      "49460" : "MANZANILLA DE LA PAZ", 
      "46900" : "MASCOTA", 
      "49500" : "MAZAMITLA", 
      "47340" : "MEXTICACAN", 
      "46040" : "MEZQUITIC", 
      "46850" : "MIXTLAN", 
      "47780" : "OCOTLAN", 
      "47540" : "OJUELOS DE JALISCO", 
      "49870" : "PIHUAMO", 
      "45950" : "PONCITLAN", 
      "48260" : "PUERTO VALLARTA", 
      "49570" : "QUITUPAN", 
      "45250" : "SAN CRISTOBAL DE LA BARRANCA", 
      "47590" : "SAN DIEGO DE ALEJANDRIA", 
      "47000" : "SAN JUAN DE LOS LAGOS", 
      "47170" : "SAN JULIAN", 
      "46540" : "SAN MARCOS", 
      "46350" : "SAN MARTIN DE BOLANOS", 
      "46770" : "SAN MARTIN HIDALGO", 
      "47140" : "SAN MIGUEL EL ALTO", 
      "46960" : "SAN SEBASTIAN DEL OESTE", 
      "46240" : "SANTA MARIA DE LOS ANGELES", 
      "49970" : "SANTA MARIA DEL ORO", 
      "49300" : "SAYULA", 
      "45300" : "TALA", 
      "48200" : "TALPA DE ALLENDE", 
      "49650" : "TAMAZULA DE GORDIANO", 
      "49340" : "TAPALPA", 
      "49900" : "TECALITLAN", 
      "49230" : "TECHALUTA DE MONTENEGRO", 
      "48540" : "TECOLOTLAN", 
      "48570" : "TENAMAXTLAN", 
      "47200" : "TEOCALTICHE", 
      "49250" : "TEOCUITATLAN DE CORONA", 
      "47600" : "TEPATITLAN DE MORELOS", 
      "46400" : "TEQUILA", 
      "46760" : "TEUCHITLAN", 
      "49400" : "TIZAPAN EL ALTO", 
      "45640" : "TLAJOMULCO DE ZUNIGA", 
      "45500" : "TLAQUEPAQUE", 
      "49750" : "TOLIMAN", 
      "48450" : "TOMATLAN", 
      "45400" : "TONALA", 
      "48760" : "TONAYA", 
      "49840" : "TONILA", 
      "46170" : "TOTATICHE", 
      "47730" : "TOTOTLAN", 
      "48770" : "TUXCACUESCO", 
      "49430" : "TUXCUECA", 
      "49800" : "TUXPAN", 
      "47570" : "UNION DE SAN ANTONIO", 
      "48000" : "UNION DE TULA", 
      "47380" : "VALLE DE GUADALUPE", 
      "49540" : "VALLE DE JUAREZ", 
      "45730" : "VILLA CORONA", 
      "46100" : "VILLA GUERRERO", 
      "47250" : "VILLA HIDALGO", 
      "48800" : "VILLA PURIFICACION", 
      "47300" : "YAHUALICA DE GONZALEZ GALLO", 
      "45750" : "ZACOALCO DE TORRES", 
      "45010" : "ZAPOPAN", 
      "49600" : "ZAPOTILTIC", 
      "49770" : "ZAPOTITLAN DE VADILLO", 
      "45980" : "ZAPOTLAN DEL REY", 
      "45430" : "ZAPOTLANEJO", 
    }, 
    "MI" : {
      "58460" : "ACUITZIO", 
      "60570" : "AGUILILLA", 
      "58920" : "ALVARO OBREGON", 
      "58550" : "ANGAMACUTIRO", 
      "61410" : "ANGANGUEO", 
      "60600" : "APATZINGAN", 
      "61400" : "APORO", 
      "60870" : "AQUILA", 
      "61830" : "ARIO", 
      "60920" : "ARTEAGA", 
      "59120" : "BRISENAS", 
      "60500" : "BUENAVISTA", 
      "61920" : "CARACUARO", 
      "60240" : "CHARAPAN", 
      "61300" : "CHARO", 
      "59580" : "CHAVINDA", 
      "60270" : "CHERAN", 
      "59780" : "CHILCHOTA", 
      "60820" : "CHINICUILA", 
      "58860" : "CHUCANDIRO", 
      "59440" : "CHURINTZIO", 
      "61880" : "CHURUMUCO", 
      "60800" : "COAHUAYANA", 
      "60840" : "COALCOMAN DE VAZQUEZ PALLARES", 
      "58400" : "COENEO", 
      "59140" : "COJUMATLAN DE REGULES", 
      "61020" : "CONTEPEC", 
      "58870" : "COPANDARO", 
      "59940" : "COTIJA", 
      "58840" : "CUITZEO", 
      "59730" : "ECUANDUREO", 
      "61000" : "EPITACIO HUERTA", 
      "61630" : "ERONGARICUARO", 
      "61730" : "GABRIEL ZAMORA", 
      "61100" : "HIDALGO", 
      "58820" : "HUANDACAREO", 
      "58360" : "HUANIQUEO", 
      "61940" : "HUETAMO", 
      "61640" : "HUIRAMBA", 
      "58970" : "INDAPARAPEO", 
      "61280" : "IRIMBO", 
      "59280" : "IXTLAN", 
      "59800" : "JACONA", 
      "58780" : "JIMENEZ", 
      "59510" : "JIQUILPAN", 
      "58540" : "JOSE SIXTO VERDUZCO", 
      "61570" : "JUAREZ", 
      "61470" : "JUNGAPEO", 
      "61850" : "LA HUACANA", 
      "59300" : "LA PIEDAD", 
      "58450" : "LAGUNILLAS", 
      "60950" : "LAZARO CARDENAS", 
      "60300" : "LOS REYES", 
      "58480" : "MADERO", 
      "61250" : "MARAVATIO", 
      "59500" : "MARCOS CASTELLANOS", 
      "58000" : "MORELIA", 
      "58800" : "MORELOS", 
      "61760" : "MUGICA", 
      "60280" : "NAHUATZEN", 
      "61900" : "NOCUPETARO", 
      "60490" : "NUEVO PARANGARICUTIRO", 
      "61750" : "NUEVO URECHO", 
      "59430" : "NUMARAN", 
      "61450" : "OCAMPO", 
      "59180" : "PAJACUARAN", 
      "58570" : "PANINDICUARO", 
      "60250" : "PARACHO", 
      "60760" : "PARACUARO", 
      "61600" : "PATZCUARO", 
      "59470" : "PENJAMILLO", 
      "60440" : "PERIBAN", 
      "58760" : "PUREPERO", 
      "58500" : "PURUANDIRO", 
      "58980" : "QUERENDARO", 
      "58420" : "QUIROGA", 
      "59000" : "SAHUAYO", 
      "61800" : "SALVADOR ESCALANTE", 
      "61980" : "SAN LUCAS", 
      "58900" : "SANTA ANA MAYA", 
      "61290" : "SENGUIO", 
      "61590" : "SUSUPUATO", 
      "61650" : "TACAMBARO", 
      "60460" : "TANCITARO", 
      "59920" : "TANGAMANDAPIO", 
      "59750" : "TANGANCICUARO", 
      "59230" : "TANHUATO", 
      "61710" : "TARETAN", 
      "58880" : "TARIMBARO", 
      "60540" : "TEPALCATEPEC", 
      "60290" : "TINGAMBATO", 
      "59980" : "TINGUINDIN", 
      "61370" : "TIQUICHEO DE NICOLAS ROMERO", 
      "61060" : "TLALPUJAHUA", 
      "58740" : "TLAZAZALCA", 
      "59960" : "TOCUMBO", 
      "60900" : "TUMBISCATIO", 
      "61680" : "TURICATO", 
      "61420" : "TUXPAN", 
      "61540" : "TUZANTLA", 
      "58440" : "TZINTZUNTZAN", 
      "61330" : "TZITZIO", 
      "60000" : "URUAPAN", 
      "59160" : "VENUSTIANO CARRANZA", 
      "59550" : "VILLAMAR", 
      "59200" : "VISTA HERMOSA", 
      "59250" : "YURECUARO", 
      "58600" : "ZACAPU", 
      "59600" : "ZAMORA", 
      "59460" : "ZINAPARO", 
      "58930" : "ZINAPECUARO", 
      "61700" : "ZIRACUARETIRO", 
      "61500" : "ZITACUARO", 
    }, 
    "MO" : {
      "62797" : "ALPUYECA", 
      "62640" : "AMACUZAC", 
      "62840" : "ATLATLAHUCAN", 
      "62950" : "AXOCHIAPAN", 
      "62700" : "AYALA", 
      "62610" : "COATLAN DEL RIO", 
      "62740" : "CUAUTLA", 
      "62000" : "CUERNAVACA", 
      "62760" : "EMILIANO ZAPATA", 
      "62510" : "HUITZILAC", 
      "62970" : "JANTETELCO", 
      "62550" : "JIUTEPEC", 
      "62900" : "JOJUTLA", 
      "62930" : "JONACATEPEC", 
      "62630" : "MAZATEPEC", 
      "62600" : "MIACATLAN", 
      "62850" : "OCUITUCO", 
      "62660" : "PUENTE DE IXTLA", 
      "62580" : "TEMIXCO", 
      "62870" : "TEMOAC", 
      "62920" : "TEPALCINGO", 
      "62520" : "TEPOZTLAN", 
      "62620" : "TETECALA", 
      "62800" : "TETELA DEL VOLCAN", 
      "62530" : "TLALNEPANTLA", 
      "62770" : "TLALTIZAPAN", 
      "62980" : "TLAQUILTENANGO", 
      "62540" : "TLAYACAPAN", 
      "62830" : "TOTOLAPAN", 
      "62790" : "XOCHITEPEC", 
      "62730" : "YAUTEPEC", 
      "62820" : "YECAPIXTLA", 
      "62780" : "ZACATEPEC", 
      "62890" : "ZACUALPAN", 
    }, 
    "NA" : {
      "63400" : "ACAPONETA", 
      "63900" : "AHUACATLAN", 
      "63960" : "AMATLAN DE CANAS", 
      "63725" : "BAHIA DE BANDERAS", 
      "63700" : "COMPOSTELA", 
      "63530" : "EL NAYAR", 
      "63480" : "HUAJICORI", 
      "63940" : "IXTLAN DEL RIO", 
      "63880" : "JALA", 
      "63580" : "LA YESCA", 
      "63630" : "ROSAMORADA", 
      "63600" : "RUIZ", 
      "63740" : "SAN BLAS", 
      "63800" : "SAN PEDRO LAGUNILLAS", 
      "63830" : "SANTA MARIA DEL ORO", 
      "63300" : "SANTIAGO IXCUINTLA", 
      "63440" : "TECUALA", 
      "63000" : "TEPIC", 
      "63200" : "TUXPAN", 
      "63742" : "XALISCO", 
    }, 
    "NL" : {
      "65650" : "ABASOLO", 
      "65800" : "AGUALEGUAS", 
      "67350" : "ALLENDE", 
      "65000" : "ANAHUAC", 
      "66600" : "APODACA", 
      "67940" : "ARAMBERRI", 
      "65150" : "BUSTAMANTE", 
      "67451" : "CADEREYTA JIMENEZ", 
      "66550" : "CARMEN", 
      "65900" : "CERRALVO", 
      "67050" : "CHINA", 
      "65550" : "CIENEGA DE FLORES", 
      "67900" : "DOCTOR ARROYO", 
      "66950" : "DOCTOR COSS", 
      "66750" : "DOCTOR GONZALEZ", 
      "67850" : "GALEANA", 
      "66000" : "GARCIA", 
      "67000" : "GENERAL BRAVO", 
      "66050" : "GENERAL ESCOBEDO", 
      "67400" : "GENERAL TERAN", 
      "65850" : "GENERAL TREVINO", 
      "67960" : "GENERAL ZARAGOZA", 
      "65750" : "GENERAL ZUAZUA", 
      "67100" : "GUADALUPE", 
      "65600" : "HIDALGO", 
      "65700" : "HIGUERAS", 
      "67880" : "HUALAHUISES", 
      "67830" : "ITURBIDE", 
      "67250" : "JUAREZ", 
      "65070" : "LAMPAZOS DE NARANJO", 
      "67700" : "LINARES", 
      "66900" : "LOS ALDAMAS", 
      "66850" : "LOS HERRERAS", 
      "66800" : "LOS RAMONES", 
      "66700" : "MARIN", 
      "65950" : "MELCHOR OCAMPO", 
      "67980" : "MIER Y NORIEGA", 
      "65100" : "MINA", 
      "67500" : "MONTEMORELOS", 
      "64000" : "MONTERREY", 
      "65450" : "PARAS", 
      "66650" : "PESQUERIA", 
      "67650" : "RAYONES", 
      "65050" : "RODRIGUEZ", 
      "65200" : "SABINAS HIDALGO", 
      "65500" : "SALINAS VICTORIA", 
      "66400" : "SAN NICOLAS DE LOS GARZA", 
      "66200" : "SAN PEDRO GARZA GARCIA", 
      "66100" : "SANTA CATARINA", 
      "67300" : "SANTIAGO", 
      "65400" : "VALLECILLO", 
      "65350" : "VILLALDAMA", 
    }, 
    "OA" : {
      "68715" : "ABEJONES", 
      "68420" : "ACATLAN DE PEREZ FIGUEROA", 
      "71244" : "ANIMAS TRUJANO", 
      "70290" : "ASUNCION CACALOTEPEC", 
      "69070" : "ASUNCION CUYOTEPEJI", 
      "70140" : "ASUNCION IXTALTEPEC", 
      "69600" : "ASUNCION NOCHIXTLAN", 
      "71523" : "ASUNCION OCOTLAN", 
      "70570" : "ASUNCION TLACOLULITA", 
      "71290" : "AYOQUEZCO DE ALDAMA", 
      "68435" : "AYOTZINTEPEC", 
      "69450" : "CALIHUALA", 
      "70950" : "CANDELARIA LOXICHA", 
      "68760" : "CAPULALPAM DE MENDEZ", 
      "70190" : "CHAHUITES", 
      "71100" : "CHALCATONGO DE HIDALGO", 
      "71260" : "CIENEGA DE ZIMATLAN {LA CIENE", 
      "70110" : "CIUDAD IXTEPEC", 
      "71570" : "COATECAS ALTAS", 
      "69790" : "COICOYAN DE LAS FLORES", 
      "69320" : "CONCEPCION BUENAVISTA", 
      "68640" : "CONCEPCION PAPALO", 
      "71030" : "CONSTANCIA DEL ROSARIO", 
      "68410" : "COSOLAPA", 
      "69020" : "COSOLTEPEC", 
      "71240" : "CUILAPAM DE GUERRERO", 
      "68610" : "CUYAMECALCO VILLA DE ZARAGOZA", 
      "71500" : "EJUTLA DE CRESPO", 
      "70380" : "EL BARRIO DE LA SOLEDAD", 
      "70117" : "EL ESPINAL", 
      "68530" : "ELOXOCHITLAN DE FLORES MAGON", 
      "69210" : "FRESNILLO DE TRUJANO", 
      "68256" : "GUADALUPE ETLA", 
      "69150" : "GUADALUPE RAMIREZ", 
      "68770" : "GUELATAO DE JUAREZ", 
      "70725" : "GUEVEA DE HUMBOLDT", 
      "69800" : "HEROICA CIUDAD DE TLAXIACO", 
      "69000" : "HUAJUAPAN DE LEON", 
      "68555" : "HUAUTEPEC", 
      "68500" : "HUAUTLA DE JIMENEZ", 
      "69470" : "IXPANTEPEC NIEVES", 
      "68725" : "IXTLAN DE JUAREZ", 
      "70000" : "JUCHITAN DE ZARAGOZA", 
      "71567" : "LA COMPANIA", 
      "71565" : "LA PE", 
      "71080" : "LA REFORMA", 
      "69507" : "LA TRINIDAD VISTA HERMOSA", 
      "68400" : "LOMA BONITA", 
      "68226" : "MAGDALENA APASCO", 
      "69900" : "MAGDALENA JALTEPEC", 
      "71286" : "MAGDALENA MIXTEPEC", 
      "71529" : "MAGDALENA OCOTLAN", 
      "69848" : "MAGDALENA PENASCO", 
      "70458" : "MAGDALENA TEITIPAC", 
      "70740" : "MAGDALENA TEQUISISTLAN", 
      "70746" : "MAGDALENA TLACOTEPEC", 
      "69910" : "MAGDALENA YODOCONO DE PORFIRIO", 
      "69920" : "MAGDALENA ZAHUATLAN", 
      "69250" : "MARISCALA DE JUAREZ", 
      "71630" : "MARTIRES DE TACUBAYA", 
      "70300" : "MATIAS ROMERO", 
      "68580" : "MAZATLAN VILLA DE FLORES", 
      "71040" : "MESONES HIDALGO", 
      "70800" : "MIAHUATLAN DE PORFIRIO DIAZ", 
      "70260" : "MIXISTLAN DE LA REFORMA", 
      "70826" : "MONJAS", 
      "68700" : "NATIVIDAD", 
      "68240" : "NAZARENO ETLA", 
      "70530" : "NEJAPA DE MADERO", 
      "68430" : "NUEVO SOYALTEPEC", 
      "68764" : "NUEVO ZOQUIAPAM", 
      "68000" : "OAXACA DE JUAREZ", 
      "71510" : "OCOTLAN DE MORELOS", 
      "71750" : "PINOTEPA DE DON LUIS", 
      "70960" : "PLUMA HIDALGO", 
      "71000" : "PUTLA VILLA DE GUERRERO", 
      "70170" : "REFORMA DE PINEDA", 
      "68237" : "REYES ETLA", 
      "70450" : "ROJAS DE CUAUHTEMOC", 
      "70600" : "SALINA CRUZ", 
      "71580" : "SAN AGUSTIN AMATENGO", 
      "69440" : "SAN AGUSTIN ATENANGO", 
      "71764" : "SAN AGUSTIN CHAYUCO", 
      "71238" : "SAN AGUSTIN DE LAS JUNTAS", 
      "68247" : "SAN AGUSTIN ETLA", 
      "70920" : "SAN AGUSTIN LOXICHA", 
      "69860" : "SAN AGUSTIN TLACOTEPEC", 
      "68290" : "SAN AGUSTIN YATARENI", 
      "71170" : "SAN ANDRES CABECERA NUEVA", 
      "69064" : "SAN ANDRES DINICUITI", 
      "71770" : "SAN ANDRES HUAXPALTEPEC", 
      "68287" : "SAN ANDRES HUAYAPAM", 
      "71224" : "SAN ANDRES IXTLAHUACA", 
      "69550" : "SAN ANDRES LAGUNAS", 
      "69950" : "SAN ANDRES NUXINO", 
      "70868" : "SAN ANDRES PAXTLAN", 
      "69665" : "SAN ANDRES SINAXTLA", 
      "68844" : "SAN ANDRES SOLAGA", 
      "68630" : "SAN ANDRES TEOTILALPAM", 
      "69160" : "SAN ANDRES TEPETLAPA", 
      "68854" : "SAN ANDRES YAA", 
      "71548" : "SAN ANDRES ZABACHE", 
      "68244" : "SAN ANDRES ZAUTLA", 
      "71520" : "SAN ANTONINO CASTILLO VELASCO", 
      "71283" : "SAN ANTONINO EL ALTO", 
      "69546" : "SAN ANTONINO MONTE VERDE", 
      "69526" : "SAN ANTONIO ACUTLA", 
      "71236" : "SAN ANTONIO DE LA CAL", 
      "71263" : "SAN ANTONIO HUITEPEC", 
      "68565" : "SAN ANTONIO NANAHUATIPAM", 
      "69870" : "SAN ANTONIO SINICAHUA", 
      "71650" : "SAN ANTONIO TEPETLAPA", 
      "71537" : "SAN BALTAZAR CHICHICAPAM", 
      "70930" : "SAN BALTAZAR LOXICHA", 
      "68860" : "SAN BALTAZAR YATZACHI EL BAJO", 
      "71256" : "SAN BARTOLO COYOTEPEC", 
      "69565" : "SAN BARTOLO SOYALTEPEC", 
      "70550" : "SAN BARTOLO YAUTEPEC", 
      "68577" : "SAN BARTOLOME AYAUTLA", 
      "70940" : "SAN BARTOLOME LOXICHA", 
      "70474" : "SAN BARTOLOME QUIALANA", 
      "69850" : "SAN BARTOLOME YUCUANE", 
      "68857" : "SAN BARTOLOME ZOOGOCHO", 
      "71210" : "SAN BERNARDO MIXTEPEC", 
      "70786" : "SAN BLAS ATEMPA", 
      "70500" : "SAN CARLOS YAUTEPEC", 
      "70835" : "SAN CRISTOBAL AMATLAN", 
      "69837" : "SAN CRISTOBAL AMOLTEPEC", 
      "68830" : "SAN CRISTOBAL LACHIRIOAG", 
      "69380" : "SAN CRISTOBAL SUCHIXTLAHUACA", 
      "70137" : "SAN DIONISIO DEL MAR", 
      "70495" : "SAN DIONISIO OCOTEPEC", 
      "71526" : "SAN DIONISIO OCOTLAN", 
      "71120" : "SAN ESTEBAN ATATLAHUCA", 
      "68460" : "SAN FELIPE JALAPA DE DIAZ", 
      "68260" : "SAN FELIPE TEJALAPAM", 
      "68490" : "SAN FELIPE USILA", 
      "71320" : "SAN FRANCISCO CAHUACUA", 
      "68875" : "SAN FRANCISCO CAJONOS", 
      "68635" : "SAN FRANCISCO CHAPULAPA", 
      "69685" : "SAN FRANCISCO CHINDUA", 
      "70146" : "SAN FRANCISCO DEL MAR", 
      "68520" : "SAN FRANCISCO HUEHUETLAN", 
      "70175" : "SAN FRANCISCO IXHUATAN", 
      "69935" : "SAN FRANCISCO JALTEPETONGO", 
      "70424" : "SAN FRANCISCO LACHIGOLO", 
      "70818" : "SAN FRANCISCO LOGUECHE", 
      "69925" : "SAN FRANCISCO NUXANO", 
      "70887" : "SAN FRANCISCO OZOLOTEPEC", 
      "71470" : "SAN FRANCISCO SOLA", 
      "68213" : "SAN FRANCISCO TELIXTLAHUACA", 
      "69345" : "SAN FRANCISCO TEOPAN", 
      "69480" : "SAN FRANCISCO TLAPANCINGO", 
      "71970" : "SAN GABRIEL MIXTEPEC", 
      "70828" : "SAN ILDEFONSO AMATLAN", 
      "71480" : "SAN ILDEFONSO SOLA", 
      "68800" : "SAN ILDEFONSO VILLA ALTA", 
      "68285" : "SAN JACINTO AMILPAS", 
      "71390" : "SAN JACINTO TLACOTEPEC", 
      "70843" : "SAN JERONIMO COATLAN", 
      "69055" : "SAN JERONIMO SILACAYOAPILLA", 
      "68207" : "SAN JERONIMO SOSOLA", 
      "71545" : "SAN JERONIMO TAVICHE", 
      "68550" : "SAN JERONIMO TECOATL", 
      "70460" : "SAN JERONIMO TLACOCHAHUAYA", 
      "69280" : "SAN JORGE NUCHITA", 
      "69230" : "SAN JOSE AYUQUILA", 
      "68456" : "SAN JOSE CHILTEPEC", 
      "70833" : "SAN JOSE DEL PENASCO", 
      "71550" : "SAN JOSE DEL PROGRESO", 
      "71686" : "SAN JOSE ESTANCIA GRANDE", 
      "68407" : "SAN JOSE INDEPENDENCIA", 
      "70813" : "SAN JOSE LACHIGUIRI", 
      "68570" : "SAN JOSE TENANGO", 
      "69830" : "SAN JUAN ACHIUTLA", 
      "68730" : "SAN JUAN ATEPEC", 
      "68204" : "SAN JUAN BAUTISTA ATATLAHUCA", 
      "69300" : "SAN JUAN BAUTISTA COIXTLAHUACA", 
      "68600" : "SAN JUAN BAUTISTA CUICATLAN", 
      "68234" : "SAN JUAN BAUTISTA GUELACHE", 
      "68210" : "SAN JUAN BAUTISTA JAYACATLAN", 
      "71620" : "SAN JUAN BAUTISTA LO DE SOTO", 
      "69040" : "SAN JUAN BAUTISTA SUCHITEPEC", 
      "69190" : "SAN JUAN BAUTISTA TLACHICHILCO", 
      "68650" : "SAN JUAN BAUTISTA TLACOATZINTE", 
      "68300" : "SAN JUAN BAUTISTA TUXTEPEC", 
      "68480" : "SAN JUAN BAUTISTA VALLE NACION", 
      "71610" : "SAN JUAN CACAHUATEPEC", 
      "68757" : "SAN JUAN CHICOMEZUCHIL", 
      "71508" : "SAN JUAN CHILATECA", 
      "68617" : "SAN JUAN CHIQUIHUITLAN", 
      "69110" : "SAN JUAN CIENEGUILLA", 
      "68557" : "SAN JUAN COATZOSPAM", 
      "71720" : "SAN JUAN COLORADO", 
      "68990" : "SAN JUAN COMALTEPEC", 
      "70210" : "SAN JUAN COTZOCON", 
      "68585" : "SAN JUAN DE LOS CUES", 
      "68224" : "SAN JUAN DEL ESTADO", 
      "70470" : "SAN JUAN DEL RIO", 
      "69946" : "SAN JUAN DIUXI", 
      "68748" : "SAN JUAN EVANGELISTA ANALCO", 
      "70464" : "SAN JUAN GUELAVIA", 
      "70330" : "SAN JUAN GUICHICOVI", 
      "69130" : "SAN JUAN IHUALTEPEC", 
      "70520" : "SAN JUAN JUQUILA MIXES", 
      "68827" : "SAN JUAN JUQUILA VIJANOS", 
      "71940" : "SAN JUAN LACHAO", 
      "71575" : "SAN JUAN LACHIGALLA", 
      "70546" : "SAN JUAN LAJARCIA", 
      "68940" : "SAN JUAN LALANA", 
      "70230" : "SAN JUAN MAZATLAN", 
      "69770" : "SAN JUAN MIXTEPEC JUXTLAHUACA", 
      "70838" : "SAN JUAN MIXTEPEC MIAHUATLAN", 
      "69807" : "SAN JUAN NUMI", 
      "70897" : "SAN JUAN OZOLOTEPEC", 
      "68980" : "SAN JUAN PETLAPA", 
      "71870" : "SAN JUAN QUIAHIJE", 
      "68704" : "SAN JUAN QUIOTEPEC", 
      "69675" : "SAN JUAN SAYULTEPEC", 
      "68847" : "SAN JUAN TABAA", 
      "69955" : "SAN JUAN TAMAZOLA", 
      "69895" : "SAN JUAN TEITA", 
      "70453" : "SAN JUAN TEITIPAC", 
      "68660" : "SAN JUAN TEPEUXILA", 
      "69560" : "SAN JUAN TEPOSCOLULA", 
      "68810" : "SAN JUAN YAE", 
      "68817" : "SAN JUAN YATZONA", 
      "69670" : "SAN JUAN YUCUITA", 
      "71760" : "SAN LORENZO", 
      "70477" : "SAN LORENZO ALBARRADAS", 
      "68263" : "SAN LORENZO CACAOTEPEC", 
      "68518" : "SAN LORENZO CUAUNECUILTITLA", 
      "71450" : "SAN LORENZO TEXMELUCAN", 
      "69430" : "SAN LORENZO VICTORIA", 
      "70296" : "SAN LUCAS CAMOTLAN", 
      "68470" : "SAN LUCAS OJITLAN", 
      "70467" : "SAN LUCAS QUIAVINI", 
      "68560" : "SAN LUCAS ZOQUIAPAM", 
      "70810" : "SAN LUIS AMATLAN", 
      "70894" : "SAN MARCIAL OZOLOTEPEC", 
      "69270" : "SAN MARCOS ARTEAGA", 
      "71560" : "SAN MARTIN DE LOS CANSECOS", 
      "69815" : "SAN MARTIN HUAMELULPAM", 
      "69845" : "SAN MARTIN ITUNYOSO", 
      "71562" : "SAN MARTIN LACHILA", 
      "69780" : "SAN MARTIN PERAS", 
      "71506" : "SAN MARTIN TILCAJETE", 
      "68547" : "SAN MARTIN TOXPALAN", 
      "69235" : "SAN MARTIN ZACATEPEC", 
      "68880" : "SAN MATEO CAJONOS", 
      "70780" : "SAN MATEO DEL MAR", 
      "69690" : "SAN MATEO ETLATONGO", 
      "69180" : "SAN MATEO NEJAPAM", 
      "69875" : "SAN MATEO PENASCO", 
      "70970" : "SAN MATEO PINAS", 
      "70860" : "SAN MATEO RIO HONDO", 
      "69995" : "SAN MATEO SINDIHUI", 
      "69355" : "SAN MATEO TLAPILTEPEC", 
      "68575" : "SAN MATEO YOLOXOCHITLAN", 
      "68850" : "SAN MELCHOR BETAZA", 
      "69840" : "SAN MIGUEL ACHIUTLA", 
      "69170" : "SAN MIGUEL AHUEHUETITLAN", 
      "68737" : "SAN MIGUEL ALOAPAM", 
      "69240" : "SAN MIGUEL AMATITLAN", 
      "68785" : "SAN MIGUEL AMATLAN", 
      "69615" : "SAN MIGUEL CHICAHUA", 
      "70155" : "SAN MIGUEL CHIMALAPA", 
      "70874" : "SAN MIGUEL COATLAN", 
      "70990" : "SAN MIGUEL DEL PUERTO", 
      "68754" : "SAN MIGUEL DEL RIO", 
      "71588" : "SAN MIGUEL EJUTLA", 
      "71140" : "SAN MIGUEL EL GRANDE", 
      "69610" : "SAN MIGUEL HUAUTLA", 
      "71218" : "SAN MIGUEL MIXTEPEC", 
      "71890" : "SAN MIGUEL PANIXTLAHUACA", 
      "71273" : "SAN MIGUEL PERAS", 
      "69990" : "SAN MIGUEL PIEDRAS", 
      "70288" : "SAN MIGUEL QUETZALTEPEC", 
      "68624" : "SAN MIGUEL SANTA FLOR", 
      "70880" : "SAN MIGUEL SUCHIXTEPEC", 
      "68820" : "SAN MIGUEL TALEA DE CASTRO", 
      "69915" : "SAN MIGUEL TECOMATLAN", 
      "70795" : "SAN MIGUEL TENANGO", 
      "69360" : "SAN MIGUEL TEQUIXTEPEC", 
      "71530" : "SAN MIGUEL TILQUIAPAM", 
      "71670" : "SAN MIGUEL TLACAMAMA", 
      "69730" : "SAN MIGUEL TLACOTEPEC", 
      "69370" : "SAN MIGUEL TULANCINGO", 
      "68778" : "SAN MIGUEL YOTAO", 
      "70806" : "SAN NICOLAS", 
      "69140" : "SAN NICOLAS HIDALGO", 
      "70855" : "SAN PABLO COATLAN", 
      "71276" : "SAN PABLO CUATRO VENADOS", 
      "68258" : "SAN PABLO ETLA", 
      "68220" : "SAN PABLO HUITZO", 
      "71270" : "SAN PABLO HUIXTEPEC", 
      "68720" : "SAN PABLO MACUILTIANGUIS", 
      "71150" : "SAN PABLO TIJALTEPEC", 
      "70430" : "SAN PABLO VILLA DE MITLA", 
      "68895" : "SAN PABLO YAGANIZA", 
      "71070" : "SAN PEDRO AMUZGOS", 
      "71540" : "SAN PEDRO APOSTOL", 
      "71710" : "SAN PEDRO ATOYAC", 
      "68885" : "SAN PEDRO CAJONOS", 
      "69640" : "SAN PEDRO CANTAROS COXCALTEPEC", 
      "70750" : "SAN PEDRO COMITANCILLO", 
      "70966" : "SAN PEDRO EL ALTO", 
      "70770" : "SAN PEDRO HUAMELULA", 
      "70777" : "SAN PEDRO HUILOTEPEC", 
      "68450" : "SAN PEDRO IXCATLAN", 
      "71234" : "SAN PEDRO IXTLAHUACA", 
      "68685" : "SAN PEDRO JALTEPETONGO", 
      "71740" : "SAN PEDRO JICAYAN", 
      "68675" : "SAN PEDRO JOCOTIPAC", 
      "71920" : "SAN PEDRO JUCHATENGO", 
      "71525" : "SAN PEDRO MARTIR", 
      "70580" : "SAN PEDRO MARTIR QUIECHAPA", 
      "69810" : "SAN PEDRO MARTIR YUCUXACO", 
      "71980" : "SAN PEDRO MIXTEPEC-JUQUILA", 
      "70839" : "SAN PEDRO MIXTEPEC-MIAHUATLAN", 
      "69885" : "SAN PEDRO MOLINOS", 
      "69516" : "SAN PEDRO NOPALA", 
      "68524" : "SAN PEDRO OCOPETATILLO", 
      "70293" : "SAN PEDRO OCOTEPEC", 
      "70900" : "SAN PEDRO POCHUTLA", 
      "70486" : "SAN PEDRO QUIATONI", 
      "68665" : "SAN PEDRO SOCHIAPAM", 
      "70180" : "SAN PEDRO TAPANATEPEC", 
      "71557" : "SAN PEDRO TAVICHE", 
      "69980" : "SAN PEDRO TEOZACOALCO", 
      "68620" : "SAN PEDRO TEUTILA", 
      "69930" : "SAN PEDRO TIDAA", 
      "69590" : "SAN PEDRO TOPILTEPEC", 
      "70480" : "SAN PEDRO TOTOLAPA", 
      "71800" : "SAN PEDRO TUTUTEPEC", 
      "70283" : "SAN PEDRO Y SAN PABLO AYUTLA", 
      "69500" : "SAN PEDRO Y SAN PABLO TEPOSCOL", 
      "69030" : "SAN PEDRO Y SAN PABLO TEQUIXT", 
      "68734" : "SAN PEDRO YANERI", 
      "68707" : "SAN PEDRO YOLOX", 
      "69556" : "SAN PEDRO YUCUNAMA", 
      "71248" : "SAN RAYMUNDO JALPAN", 
      "70407" : "SAN SEBASTIAN ABASOLO", 
      "70850" : "SAN SEBASTIAN COATLAN", 
      "71640" : "SAN SEBASTIAN IXCAPA", 
      "69574" : "SAN SEBASTIAN NICANANDUTA", 
      "70877" : "SAN SEBASTIAN RIO HONDO", 
      "69740" : "SAN SEBASTIAN TECOMAXTLAHUACA", 
      "70426" : "SAN SEBASTIAN TEITIPAC", 
      "71246" : "SAN SEBASTIAN TUTLA", 
      "70808" : "SAN SIMON ALMOLONGAS", 
      "69265" : "SAN SIMON ZAHUATLAN", 
      "71595" : "SAN VICENTE COATLAN", 
      "71440" : "SAN VICENTE LACHIXIO", 
      "69585" : "SAN VICENTE NUNU", 
      "70820" : "SANTA ANA", 
      "68515" : "SANTA ANA ATEIXTLAHUACA", 
      "68614" : "SANTA ANA CUAUHTEMOC", 
      "70428" : "SANTA ANA DEL VALLE", 
      "70540" : "SANTA ANA TAVELA", 
      "71296" : "SANTA ANA TLAPACOYAN", 
      "68745" : "SANTA ANA YARENI", 
      "71516" : "SANTA ANA ZEGACHE", 
      "70595" : "SANTA CATALINA QUIERI", 
      "70830" : "SANTA CATARINA CUIXTLA", 
      "68774" : "SANTA CATARINA IXTEPEJI", 
      "71900" : "SANTA CATARINA JUQUILA", 
      "68780" : "SANTA CATARINA LACHATAO", 
      "70910" : "SANTA CATARINA LOXICHA", 
      "71780" : "SANTA CATARINA MECHOACAN", 
      "71534" : "SANTA CATARINA MINAS", 
      "71287" : "SANTA CATARINA QUIANE", 
      "70590" : "SANTA CATARINA QUIOQUITANI", 
      "69834" : "SANTA CATARINA TAYATA", 
      "71125" : "SANTA CATARINA TICUA", 
      "71136" : "SANTA CATARINA YOSONOTU", 
      "69045" : "SANTA CATARINA ZAPOQUILA", 
      "68527" : "SANTA CRUZ ACATEPEC", 
      "71226" : "SANTA CRUZ AMILPAS", 
      "69460" : "SANTA CRUZ DE BRAVO", 
      "71190" : "SANTA CRUZ ITUNDUJIA", 
      "71214" : "SANTA CRUZ MIXTEPEC", 
      "69855" : "SANTA CRUZ NUNDACO", 
      "70456" : "SANTA CRUZ PAPALUTLA", 
      "69260" : "SANTA CRUZ TACACHE DE MINA", 
      "71156" : "SANTA CRUZ TACAHUA", 
      "69820" : "SANTA CRUZ TAYATA", 
      "70823" : "SANTA CRUZ XITLA", 
      "71230" : "SANTA CRUZ XOXOCOTLAN", 
      "71300" : "SANTA CRUZ ZENZONTEPEC", 
      "71280" : "SANTA GERTRUDIS", 
      "69695" : "SANTA INES DE ZARAGOZA", 
      "71278" : "SANTA INES DEL MONTE", 
      "71259" : "SANTA INES YATZECHE", 
      "71228" : "SANTA LUCIA DEL CAMINO", 
      "70840" : "SANTA LUCIA MIAHUATLAN", 
      "71160" : "SANTA LUCIA MONTEVERDE", 
      "71543" : "SANTA LUCIA OCOTLAN", 
      "69350" : "SANTA MAGDALENA JICOTLAN", 
      "70270" : "SANTA MARIA ALOTEPEC", 
      "69620" : "SANTA MARIA APAZCO", 
      "71220" : "SANTA MARIA ATZOMPA", 
      "69080" : "SANTA MARIA CAMOTLAN", 
      "69630" : "SANTA MARIA CHACHOAPAM", 
      "69540" : "SANTA MARIA CHILAPA DE DIAZ", 
      "68510" : "SANTA MARIA CHILCHOTLA", 
      "70360" : "SANTA MARIA CHIMALAPA", 
      "70934" : "SANTA MARIA COLOTEPEC", 
      "71655" : "SANTA MARIA CORTIJO", 
      "71254" : "SANTA MARIA COYOTEPEC", 
      "69827" : "SANTA MARIA DEL ROSARIO", 
      "68297" : "SANTA MARIA DEL TULE", 
      "70560" : "SANTA MARIA ECATEPEC", 
      "70417" : "SANTA MARIA GUELACE", 
      "70735" : "SANTA MARIA GUIENAGATI", 
      "70980" : "SANTA MARIA HUATULCO", 
      "71790" : "SANTA MARIA HUAZOLOTITLAN", 
      "71090" : "SANTA MARIA IPALAPA", 
      "68595" : "SANTA MARIA IXCATLAN", 
      "68465" : "SANTA MARIA JACATEPEC", 
      "70710" : "SANTA MARIA JALAPA DEL MARQUES", 
      "68750" : "SANTA MARIA JALTIANGUIS", 
      "68553" : "SANTA MARIA LA ASUNCION", 
      "71430" : "SANTA MARIA LACHIXIO", 
      "70755" : "SANTA MARIA MIXTEQUILLA", 
      "69390" : "SANTA MARIA NATIVITAS", 
      "69580" : "SANTA MARIA NDUAYACO", 
      "70870" : "SANTA MARIA OZOLOTEPEC", 
      "68655" : "SANTA MARIA PAPALO", 
      "68266" : "SANTA MARIA PENOLES", 
      "70370" : "SANTA MARIA PETAPA", 
      "70586" : "SANTA MARIA QUIEGOLANI", 
      "71460" : "SANTA MARIA SOLA", 
      "69880" : "SANTA MARIA TATALTEPEC", 
      "68590" : "SANTA MARIA TECOMAVACA", 
      "68834" : "SANTA MARIA TEMAXCALAPA", 
      "71950" : "SANTA MARIA TEMAXCALTEPEC", 
      "68544" : "SANTA MARIA TEOPOXCO", 
      "70286" : "SANTA MARIA TEPANTLALI", 
      "68680" : "SANTA MARIA TEXCATITLAN", 
      "70265" : "SANTA MARIA TLAHUITOLTEPEC", 
      "68627" : "SANTA MARIA TLALIXTAC", 
      "70944" : "SANTA MARIA TONAMECA", 
      "70716" : "SANTA MARIA TOTOLAPILLA", 
      "70125" : "SANTA MARIA XADANI", 
      "68840" : "SANTA MARIA YALINA", 
      "68790" : "SANTA MARIA YAVESIA", 
      "71176" : "SANTA MARIA YOLOTEPEC", 
      "69890" : "SANTA MARIA YOSOYUA", 
      "71110" : "SANTA MARIA YUCUHITI", 
      "71050" : "SANTA MARIA ZACATEPEC", 
      "71370" : "SANTA MARIA ZANIZA", 
      "70490" : "SANTA MARIA ZOQUITLAN", 
      "71360" : "SANTIAGO AMOLTEPEC", 
      "69625" : "SANTIAGO APOALA", 
      "71518" : "SANTIAGO APOSTOL", 
      "70790" : "SANTIAGO ASTATA", 
      "70276" : "SANTIAGO ATITLAN", 
      "69220" : "SANTIAGO AYUQUILILLA", 
      "69065" : "SANTIAGO CACALOXTEPEC", 
      "68805" : "SANTIAGO CAMOTLAN", 
      "69010" : "SANTIAGO CHAZUMBA", 
      "68900" : "SANTIAGO CHOAPAM", 
      "68710" : "SANTIAGO COMALTEPEC", 
      "69490" : "SANTIAGO DEL RIO", 
      "69090" : "SANTIAGO HUAJOLOTITLAN", 
      "69651" : "SANTIAGO HUAUCLILLA", 
      "69330" : "SANTIAGO IHUITLAN PLUMAS", 
      "70298" : "SANTIAGO IXCUINTEPEC", 
      "71730" : "SANTIAGO IXTAYUTLA", 
      "71700" : "SANTIAGO JAMILTEPEC", 
      "68920" : "SANTIAGO JOCOTEPEC", 
      "69700" : "SANTIAGO JUXTLAHUACA", 
      "70705" : "SANTIAGO LACHIGUIRI", 
      "68814" : "SANTIAGO LALOPA", 
      "70720" : "SANTIAGO LAOLLAGA", 
      "68795" : "SANTIAGO LAXOPA", 
      "71660" : "SANTIAGO LLANO GRANDE", 
      "70440" : "SANTIAGO MATATLAN", 
      "69050" : "SANTIAGO MILTEPEC", 
      "71490" : "SANTIAGO MINAS", 
      "68690" : "SANTIAGO NACALTEPEC", 
      "69595" : "SANTIAGO NEJAPILLA", 
      "70130" : "SANTIAGO NILTEPEC", 
      "69824" : "SANTIAGO NUNDICHE", 
      "71130" : "SANTIAGO NUYOO", 
      "71600" : "SANTIAGO PINOTEPA NACIONAL", 
      "68230" : "SANTIAGO SUCHILQUITONGO", 
      "69100" : "SANTIAGO TAMAZOLA", 
      "71680" : "SANTIAGO TAPEXTLA", 
      "68217" : "SANTIAGO TENANGO", 
      "69375" : "SANTIAGO TEPETLAPA", 
      "71784" : "SANTIAGO TETEPEC", 
      "68535" : "SANTIAGO TEXCALCINGO", 
      "71340" : "SANTIAGO TEXTITLAN", 
      "69940" : "SANTIAGO TILANTONGO", 
      "69680" : "SANTIAGO TILLO", 
      "68268" : "SANTIAGO TLAZOYALTEPEC", 
      "70890" : "SANTIAGO XANICA", 
      "68767" : "SANTIAGO XIACUI", 
      "71930" : "SANTIAGO YAITEPEC", 
      "68960" : "SANTIAGO YAVEO", 
      "69570" : "SANTIAGO YOLOMECATL", 
      "71180" : "SANTIAGO YOSONDUA", 
      "69420" : "SANTIAGO YUCUYACHI", 
      "70200" : "SANTIAGO ZACATEPEC", 
      "68866" : "SANTIAGO ZOOCHILA", 
      "70446" : "SANTO DOMINGO ALBARRADAS", 
      "71690" : "SANTO DOMINGO ARMENTA", 
      "70730" : "SANTO DOMINGO CHIHUITAN", 
      "70906" : "SANTO DOMINGO DE MORELOS", 
      "70120" : "SANTO DOMINGO INGENIO", 
      "71146" : "SANTO DOMINGO IXCATLAN", 
      "69960" : "SANTO DOMINGO NUXAA", 
      "70884" : "SANTO DOMINGO OZOLOTEPEC", 
      "70350" : "SANTO DOMINGO PETAPA", 
      "68837" : "SANTO DOMINGO ROAYAGA", 
      "70760" : "SANTO DOMINGO TEHUANTEPEC", 
      "71380" : "SANTO DOMINGO TEOJOMULCO", 
      "70206" : "SANTO DOMINGO TEPUXTEPEC", 
      "69577" : "SANTO DOMINGO TLATAYAPAM", 
      "68293" : "SANTO DOMINGO TOMALTEPEC", 
      "69290" : "SANTO DOMINGO TONALA", 
      "69536" : "SANTO DOMINGO TONALTEPEC", 
      "68890" : "SANTO DOMINGO XAGACIA", 
      "69660" : "SANTO DOMINGO YANHUITLAN", 
      "69296" : "SANTO DOMINGO YODOHINO", 
      "70160" : "SANTO DOMINGO ZANATEPEC", 
      "71507" : "SANTO TOMAS JALIEZA", 
      "68254" : "SANTO TOMAS MAZALTEPEC", 
      "69865" : "SANTO TOMAS OCOTEPEC", 
      "70866" : "SANTO TOMAS TAMAZULAPAM", 
      "71960" : "SANTOS REYES NOPALA", 
      "68645" : "SANTOS REYES PAPALO", 
      "69760" : "SANTOS REYES TEPEJILLO", 
      "69287" : "SANTOS REYES YUCUNA", 
      "69400" : "SILACAYOAPAM", 
      "70816" : "SITIO DE XITLAPEHUA", 
      "68250" : "SOLEDAD ETLA", 
      "70280" : "TAMAZULAPAM DEL ESPIRITU SANTO", 
      "68824" : "TANETZE DE ZARAGOZA", 
      "71586" : "TANICHE", 
      "71850" : "TATALTEPEC DE VALDES", 
      "68740" : "TEOCOCUILCO DE MARCOS PEREZ", 
      "68540" : "TEOTITLAN DE FLORES MAGON", 
      "70420" : "TEOTITLAN DEL VALLE", 
      "69520" : "TEOTONGO", 
      "69310" : "TEPELMEME VILLA DE MORELOS", 
      "69200" : "TEZOATLAN DE SEGURA Y LUNA", 
      "70400" : "TLACOLULA DE MATAMOROS", 
      "69340" : "TLACOTEPEC PLUMAS", 
      "68270" : "TLALIXTAC DE CABRERA", 
      "70250" : "TOTONTEPEC VILLA DE MORELOS", 
      "71268" : "TRINIDAD ZAACHILA", 
      "70150" : "UNION HIDALGO", 
      "68670" : "VALERIO TRUJANO", 
      "68200" : "VILLA DE ETLA", 
      "69510" : "VILLA DE TAMAZULAPAM DEL PROGR", 
      "71250" : "VILLA DE ZAACHILA", 
      "70410" : "VILLA DIAZ ORDAZ", 
      "68870" : "VILLA HIDALGO", 
      "71400" : "VILLA SOLA DE VEGA", 
      "69530" : "VILLA TEJUPAM DE LA UNION", 
      "71554" : "YAXE", 
      "71590" : "YOGANA", 
      "69970" : "YUTANDUCHI DE GUERRERO", 
      "71330" : "ZAPOTITLAN DEL RIO", 
      "69120" : "ZAPOTITLAN LAGUNAS", 
      "69060" : "ZAPOTITLAN PALMAS", 
      "71200" : "ZIMATLAN DE ALVAREZ", 
    }, 
    "PU" : {
      "75110" : "ACAJETE", 
      "73590" : "ACATENO", 
      "74940" : "ACATLAN", 
      "75150" : "ACATZINGO", 
      "74510" : "ACTEOPAN", 
      "73330" : "AHUACATLAN", 
      "74640" : "AHUATLAN", 
      "73180" : "AHUAZOTEPEC", 
      "74850" : "AHUEHUETITLA", 
      "75910" : "AJALPAN", 
      "74780" : "ALBINO ZERTUCHE", 
      "75180" : "ALJOJUCA", 
      "75950" : "ALTEPEXI", 
      "73360" : "AMIXTLAN", 
      "72980" : "AMOZOC", 
      "73620" : "AQUIXTLA", 
      "73940" : "ATEMPAN", 
      "75840" : "ATEXCAL", 
      "74200" : "ATLIXCO", 
      "75620" : "ATOYATEMPAN", 
      "74590" : "ATZALA", 
      "74500" : "ATZITZIHUACAN", 
      "75540" : "ATZITZINTLA", 
      "74830" : "AXUTLA", 
      "73570" : "AYOTOXCO DE GUERRERO", 
      "74180" : "CALPAN", 
      "75890" : "CALTEPEC", 
      "73420" : "CAMOCUAUTLA", 
      "75580" : "CANADA MORELOS", 
      "73520" : "CAXHUACAN", 
      "75520" : "CHALCHICOMULA DE SESMA", 
      "75810" : "CHAPULCO", 
      "74730" : "CHIAUTLA", 
      "74150" : "CHIAUTZINGO", 
      "75090" : "CHICHIQUILA", 
      "73320" : "CHICONCUAUTLA", 
      "74580" : "CHIETLA", 
      "74670" : "CHIGMECATITLAN", 
      "73298" : "CHIGNAHUAPAN", 
      "73950" : "CHIGNAUTLA", 
      "74990" : "CHILA", 
      "74760" : "CHILA DE LA SAL", 
      "73120" : "CHILA HONEY", 
      "75070" : "CHILCHOTLA", 
      "74840" : "CHINANTLA", 
      "73410" : "COATEPEC", 
      "74650" : "COATZINGO", 
      "74740" : "COHETZALA", 
      "74520" : "COHUECAN", 
      "72670" : "CORONANGO", 
      "75980" : "COXCATLAN", 
      "75990" : "COYOMEAPAN", 
      "74910" : "COYOTEPEC", 
      "75420" : "CUAPIAXTLA DE MADERO", 
      "73600" : "CUAUTEMPAN", 
      "75220" : "CUAUTINCHAN", 
      "72700" : "CUAUTLANCINGO", 
      "74810" : "CUAYUCA DE ANDRADE", 
      "73560" : "CUETZALAN DEL PROGRESO", 
      "73980" : "CUYOACO", 
      "74170" : "DOMINGO ARENAS", 
      "75920" : "ELOXOCHITLAN", 
      "74630" : "EPATLAN", 
      "75560" : "ESPERANZA", 
      "73000" : "FRANCISCO Z MENA", 
      "75170" : "GENERAL FELIPE ANGELES", 
      "74890" : "GUADALUPE", 
      "75040" : "GUADALUPE VICTORIA", 
      "73390" : "HERMENEGILDO GALEANA", 
      "74370" : "HUAQUECHULA", 
      "75380" : "HUATLATLAUCA", 
      "73160" : "HUAUCHINANGO", 
      "73470" : "HUEHUETLA", 
      "74720" : "HUEHUETLAN EL CHICO", 
      "75320" : "HUEHUETLAN EL GRANDE", 
      "74160" : "HUEJOTZINGO", 
      "73920" : "HUEYAPAN", 
      "73580" : "HUEYTAMALCO", 
      "73430" : "HUEYTLALPAN", 
      "73450" : "HUITZILAN DE SERDAN", 
      "75640" : "HUITZILTEPEC", 
      "73490" : "IGNACIO ALLENDE", 
      "74770" : "IXCAMILPA DE GUERRERO", 
      "74900" : "IXCAQUIXTLA", 
      "73720" : "IXTACAMAXTITLAN", 
      "73480" : "IXTEPEC", 
      "74400" : "IZUCAR DE MATAMOROS", 
      "73050" : "JALPAN", 
      "74710" : "JOLALPAN", 
      "73530" : "JONOTLA", 
      "73260" : "JOPALA", 
      "72640" : "JUAN C BONILLA", 
      "73200" : "JUAN GALINDO", 
      "75690" : "JUAN N MENDEZ", 
      "75340" : "LA MAGDALENA TLATLAUQUITEPEC", 
      "75060" : "LAFRAGUA", 
      "73780" : "LIBRES", 
      "75400" : "LOS REYES DE JUAREZ", 
      "75130" : "MAZAPILTEPEC DE JUAREZ", 
      "75260" : "MIXTLA", 
      "75650" : "MOLCAXAC", 
      "73140" : "NAUPAN", 
      "73550" : "NAUZONTLA", 
      "74300" : "NEALTICAN", 
      "75830" : "NICOLAS BRAVO", 
      "75120" : "NOPALUCAN", 
      "73760" : "OCOTEPEC", 
      "72850" : "OCOYUCAN", 
      "73400" : "OLINTLA", 
      "75020" : "ORIENTAL", 
      "73100" : "PAHUATLAN", 
      "75500" : "PALMAR DE BRAVO", 
      "73020" : "PANTEPEC", 
      "74970" : "PETLALCINGO", 
      "74880" : "PIAXTLA", 
      "72000" : "PUEBLA", 
      "75460" : "QUECHOLAC", 
      "75080" : "QUIMIXTLAN", 
      "75000" : "RAFAEL LARA GRAJALES", 
      "72810" : "SAN ANDRES CHOLULA", 
      "75860" : "SAN ANTONIO CANADA", 
      "74380" : "SAN DIEGO LA MESA TOCHIMILTZI", 
      "74140" : "SAN FELIPE TEOTLALCINGO", 
      "73350" : "SAN FELIPE TEPATLAN", 
      "75880" : "SAN GABRIEL CHILAC", 
      "74320" : "SAN GREGORIO ATZOMPA", 
      "74310" : "SAN JERONIMO TECUANIPAN", 
      "74950" : "SAN JERONIMO XAYACATLAN", 
      "75010" : "SAN JOSE CHIAPA", 
      "75970" : "SAN JOSE MIAHUATLAN", 
      "75190" : "SAN JUAN ATENCO", 
      "75360" : "SAN JUAN ATZOMPA", 
      "74000" : "SAN MARTIN TEXMELUCAN", 
      "74610" : "SAN MARTIN TOTOLTEPEC", 
      "74110" : "SAN MATIAS TLALANCALECA", 
      "74980" : "SAN MIGUEL IXITLAN", 
      "72620" : "SAN MIGUEL XOXTLA", 
      "75030" : "SAN NICOLAS BUENOS AIRES", 
      "74190" : "SAN NICOLAS DE LOS RANCHOS", 
      "74860" : "SAN PABLO ANICANO", 
      "72750" : "SAN PEDRO CHOLULA", 
      "74960" : "SAN PEDRO YELOIXTLAHUACA", 
      "75160" : "SAN SALVADOR EL SECO", 
      "74130" : "SAN SALVADOR EL VERDE", 
      "75440" : "SAN SALVADOR HUIXCOLOTLA", 
      "75940" : "SAN SEBASTIAN TLACOTEPEC", 
      "74660" : "SANTA CATARINA TLALTEMPAN", 
      "74820" : "SANTA INES AHUATEMPAN", 
      "74350" : "SANTA ISABEL CHOLULA", 
      "75820" : "SANTIAGO MIAHUATLAN", 
      "75280" : "SANTO TOMAS HUEYOTLIPAN", 
      "75140" : "SOLTEPEC", 
      "75240" : "TECALI DE HERRERA", 
      "75480" : "TECAMACHALCO", 
      "74870" : "TECOMATLAN", 
      "75700" : "TEHUACAN", 
      "74800" : "TEHUITZINGO", 
      "73500" : "TENAMPULCO", 
      "74600" : "TEOPANTLAN", 
      "74700" : "TEOTLALCO", 
      "75800" : "TEPANCO DE LOPEZ", 
      "73370" : "TEPANGO DE RODRIGUEZ", 
      "75100" : "TEPATLAXCO DE HIDALGO", 
      "75200" : "TEPEACA", 
      "74530" : "TEPEMAXALCO", 
      "74390" : "TEPEOJUMA", 
      "73340" : "TEPETZINTLA", 
      "74550" : "TEPEXCO", 
      "74690" : "TEPEXI DE RODRIGUEZ", 
      "73990" : "TEPEYAHUALCO", 
      "75630" : "TEPEYAHUALCO DE CUAUHTEMOC", 
      "73640" : "TETELA DE OCAMPO", 
      "73930" : "TETELES DE AVILA CASTILLO", 
      "73800" : "TEZIUTLAN", 
      "74340" : "TIANGUISMANALCO", 
      "74560" : "TILAPA", 
      "75050" : "TLACHICHUCA", 
      "75680" : "TLACOTEPEC DE BENITO JUAREZ", 
      "73070" : "TLACUILOTEPEC", 
      "74100" : "TLAHUAPAN", 
      "72600" : "TLALTENANGO", 
      "75600" : "TLANEPANTLA", 
      "73220" : "TLAOLA", 
      "73280" : "TLAPACOYA", 
      "74540" : "TLAPANALA", 
      "73900" : "TLATLAUQUITEPEC", 
      "73060" : "TLAXCO", 
      "74330" : "TOCHIMILCO", 
      "75610" : "TOCHTEPEC", 
      "74930" : "TOTOLTEPEC DE GUERRERO", 
      "74790" : "TULCINGO", 
      "73510" : "TUZAMAPAN DE GALEANA", 
      "75300" : "TZICATLACOYAN", 
      "73030" : "VENUSTIANO CARRANZA", 
      "75900" : "VICENTE GUERRERO", 
      "74920" : "XAYACATLAN DE BRAVO", 
      "73080" : "XICOTEPEC", 
      "74750" : "XICOTLAN", 
      "73970" : "XIUTETELCO", 
      "73660" : "XOCHIAPULCO", 
      "74620" : "XOCHILTEPEC", 
      "73460" : "XOCHITLAN DE VICENTE SUAREZ", 
      "75660" : "XOCHITLAN TODOS SANTOS", 
      "73910" : "YAONAHUAC", 
      "75670" : "YEHUALTEPEC", 
      "74680" : "ZACAPALA", 
      "73680" : "ZACAPOAXTLA", 
      "73310" : "ZACATLAN", 
      "75870" : "ZAPOTITLAN", 
      "73440" : "ZAPOTITLAN DE MENDEZ", 
      "73700" : "ZARAGOZA", 
      "73740" : "ZAUTLA", 
      "73240" : "ZIHUATEUTLA", 
      "75960" : "ZINACATEPEC", 
      "73380" : "ZONGOZOTLA", 
      "73540" : "ZOQUIAPAN", 
      "75930" : "ZOQUITLAN", 
    }, 
    "QT" : {
      "76850" : "AMEALCO DE BONFIL", 
      "76400" : "ARROYO SECO", 
      "76500" : "CADEREYTA DE MONTES", 
      "76270" : "COLON", 
      "76900" : "CORREGIDORA", 
      "76240" : "EL MARQUES", 
      "76650" : "EZEQUIEL MONTES", 
      "76950" : "HUIMILPAN", 
      "76340" : "JALPAN DE SERRA", 
      "76360" : "LANDA DE MATAMOROS", 
      "76700" : "PEDRO ESCOBEDO", 
      "76450" : "PENAMILLER", 
      "76300" : "PINAL DE AMOLES", 
      "76550" : "SAN JOAQUIN", 
      "76800" : "SAN JUAN DEL RIO", 
      "76000" : "SANTIAGO DE QUERETARO", 
      "76750" : "TEQUISQUIAPAN", 
      "76600" : "TOLIMAN", 
    }, 
    "QR" : {
      "77500" : "BENITO JUAREZ", 
      "77600" : "COZUMEL", 
      "77100" : "FELIPE CARRILLO PUERTO", 
      "77400" : "ISLA MUJERES", 
      "77800" : "JOSE MARIA MORELOS", 
      "77300" : "LAZARO CARDENAS", 
      "77000" : "OTHON P BLANCO", 
      "77710" : "SOLIDARIDAD", 
    }, 
    "SI" : {
      "81200" : "AHOME", 
      "81600" : "ANGOSTURA", 
      "80500" : "BADIRAGUATO", 
      "81700" : "CHOIX", 
      "82600" : "CONCORDIA", 
      "80700" : "COSALA", 
      "80000" : "CULIACAN", 
      "81800" : "EL FUERTE", 
      "82700" : "ELOTA", 
      "82400" : "ESCUINAPA", 
      "81000" : "GUASAVE", 
      "82000" : "MAZATLAN", 
      "80800" : "MOCORITO", 
      "80320" : "NAVOLATO", 
      "82800" : "ROSARIO", 
      "81400" : "SALVADOR ALVARADO", 
      "82902" : "SAN IGNACIO", 
      "81900" : "SINALOA", 
    }, 
    "SL" : {
      "78450" : "AHUALULCO", 
      "79360" : "ALAQUINES", 
      "79760" : "AQUISMON", 
      "78980" : "ARMADILLO DE LOS INFANTE", 
      "79930" : "AXTLA DE TERRAZAS", 
      "79380" : "CARDENAS", 
      "78540" : "CATORCE", 
      "78520" : "CEDRAL", 
      "79400" : "CERRITOS", 
      "78440" : "CERRO DE SAN PEDRO", 
      "78570" : "CHARCAS", 
      "79300" : "CIUDAD DEL MAIZ", 
      "79650" : "CIUDAD FERNANDEZ", 
      "78080" : "CIUDAD VALLES", 
      "79860" : "COXCATLAN", 
      "79100" : "EBANO", 
      "78870" : "GUADALCAZAR", 
      "79880" : "HUEHUETLAN", 
      "79780" : "LAGUNILLAS", 
      "78700" : "MATEHUALA", 
      "78460" : "MEXQUITIC DE CARMONA", 
      "78900" : "MOCTEZUMA", 
      "79740" : "RAYON", 
      "79600" : "RIO VERDE", 
      "78600" : "SALINAS", 
      "79830" : "SAN ANTONIO", 
      "79680" : "SAN CIRO DE ACOSTA", 
      "78000" : "SAN LUIS POTOSI", 
      "79950" : "SAN MARTIN CHALCHICUAUTLA", 
      "79480" : "SAN NICOLAS TOLENTINO", 
      "79820" : "SAN VICENTE TANCUAYALAB", 
      "79790" : "SANTA CATARINA", 
      "79560" : "SANTA MARIA DEL RIO", 
      "78630" : "SANTO DOMINGO", 
      "78430" : "SOLEDAD DE GRACIANO SANCHEZ", 
      "79702" : "TAMASOPO", 
      "79960" : "TAMAZUNCHALE", 
      "79940" : "TAMPACAN", 
      "79850" : "TAMPAMOLON CORONA", 
      "79200" : "TAMUIN", 
      "79800" : "TANCANHUITZ DE SANTOS", 
      "79810" : "TANLAJAS", 
      "79840" : "TANQUIAN DE ESCOBEDO", 
      "79590" : "TIERRANUEVA", 
      "78500" : "VANEGAS", 
      "78920" : "VENADO", 
      "78940" : "VILLA DE ARISTA", 
      "78490" : "VILLA DE ARRIAGA", 
      "78840" : "VILLA DE GUADALUPE", 
      "78830" : "VILLA DE LA PAZ", 
      "78660" : "VILLA DE RAMOS", 
      "79500" : "VILLA DE REYES", 
      "78950" : "VILLA HIDALGO", 
      "79450" : "VILLA JUAREZ", 
      "79900" : "XILITLA", 
      "79540" : "ZARAGOZA", 
    }, 
    "SO" : {
      "84920" : "ACONCHI", 
      "84200" : "AGUA PRIETA", 
      "85760" : "ALAMOS", 
      "83750" : "ALTAR", 
      "85680" : "ARIVECHI", 
      "84640" : "ARIZPE", 
      "83820" : "ATIL", 
      "84480" : "BACADEHUACHI", 
      "85660" : "BACANORA", 
      "84380" : "BACERAC", 
      "84680" : "BACOACHI", 
      "85260" : "BACUM", 
      "84880" : "BANAMICHI", 
      "84940" : "BAVIACORA", 
      "84360" : "BAVISPE", 
      "83900" : "BENJAMIN HILL", 
      "83600" : "CABORCA", 
      "85000" : "CAJEME", 
      "84620" : "CANANEA", 
      "83380" : "CARBO", 
      "84660" : "CUCURPE", 
      "84500" : "CUMPAS", 
      "84730" : "DIVISADEROS", 
      "85300" : "EMPALME", 
      "85280" : "ETCHOJOA", 
      "84320" : "FRONTERAS", 
      "83570" : "GRAL. PLUTARCO ELIAS CALLES", 
      "84460" : "GRANADOS", 
      "85400" : "GUAYMAS", 
      "83000" : "HERMOSILLO", 
      "84400" : "HUACHINERA", 
      "84530" : "HUASABAS", 
      "85240" : "HUATABAMPO", 
      "84860" : "HUEPAC", 
      "84120" : "IMURIS", 
      "85540" : "LA COLORADA", 
      "84160" : "MAGDALENA", 
      "85560" : "MAZATAN", 
      "84560" : "MOCTEZUMA", 
      "84180" : "NACO", 
      "84440" : "NACORI CHICO", 
      "84340" : "NACOZARI DE GARCIA", 
      "85220" : "NAVOJOA", 
      "84000" : "NOGALES", 
      "85740" : "ONAVAS", 
      "84800" : "OPODEPE", 
      "83840" : "OQUITOA", 
      "83960" : "PITIQUITO", 
      "83550" : "PUERTO PENASCO", 
      "85720" : "QUIRIEGO", 
      "84980" : "RAYON", 
      "85700" : "ROSARIO", 
      "85600" : "SAHUARIPA", 
      "84960" : "SAN FELIPE DE JESUS", 
      "85620" : "SAN JAVIER", 
      "83400" : "SAN LUIS RIO COLORADO", 
      "83360" : "SAN MIGUEL DE HORCASITAS", 
      "84700" : "SAN PEDRO DE LA CUEVA", 
      "84600" : "SANTA ANA", 
      "84140" : "SANTA CRUZ", 
      "83860" : "SARIC", 
      "85640" : "SOYOPA", 
      "85580" : "SUAQUI GRANDE", 
      "84750" : "TEPACHE", 
      "83930" : "TRINCHERAS", 
      "83800" : "TUBUTAMA", 
      "84900" : "URES", 
      "84580" : "VILLA HIDALGO", 
      "84770" : "VILLA PESQUEIRA", 
      "85780" : "YECORA", 
    }, 
    "TB" : {
      "86930" : "BALANCAN", 
      "86460" : "CARDENAS", 
      "86750" : "CENTLA", 
      "86000" : "CENTRO", 
      "86300" : "COMALCALCO", 
      "86680" : "CUNDUACAN", 
      "86980" : "EMILIANO ZAPATA", 
      "86400" : "HUIMANGUILLO", 
      "86830" : "JALAPA", 
      "86200" : "JALPA DE MENDEZ", 
      "86770" : "JONUTA", 
      "86700" : "MACUSPANA", 
      "86220" : "NACAJUCA", 
      "86600" : "PARAISO", 
      "86870" : "TACOTALPA", 
      "86800" : "TEAPA", 
      "86900" : "TENOSIQUE", 
    }, 
    "TL" : {
      "90860" : "ACUAMANALA DE MIG. HIDALGO", 
      "90550" : "ALTZAYANCA", 
      "90620" : "AMAXAC DE GUERRERO", 
      "90600" : "APETATITLAN DE A CARBAJAL", 
      "90300" : "APIZACO", 
      "90410" : "ATLANGATEPEC", 
      "90200" : "CALPULALPAN", 
      "90800" : "CHIAUTEMPAN", 
      "90670" : "CONTLA DE JUAN CUAMATZI", 
      "90560" : "CUAPIAXTLA", 
      "90660" : "CUAXOMULCO", 
      "90570" : "EL CARMEN TEQUEXQUITLA", 
      "90290" : "ESPANITA", 
      "90500" : "HUAMANTLA", 
      "90240" : "HUEYOTLIPAN", 
      "90120" : "IXTACUIXTLA DE M MATAMOROS", 
      "90580" : "IXTENCO", 
      "90870" : "MAZATECOCHCO DE JOSE MA MORELO", 
      "90420" : "MUNOZ DE DOMINGO ARENAS", 
      "90280" : "NANACAMILPA DE MARIANO ARISTA", 
      "90710" : "NATIVITAS", 
      "90140" : "PANOTLA", 
      "90790" : "PAPALOTLA DE XICOHTENCATL", 
      "90890" : "SAN PABLO DEL MONTE", 
      "90230" : "SANCTORUM DE LAZ. CARDENAS", 
      "90640" : "SANTA CRUZ TLAXCALA", 
      "90880" : "TENANCINGO", 
      "90850" : "TEOLOCHOLCO", 
      "90700" : "TEPETITLA DE LARDIZABAL", 
      "90180" : "TEPEYANCO", 
      "90540" : "TERRENATE", 
      "90430" : "TETLA", 
      "90730" : "TETLATLAHUCA", 
      "90000" : "TLAXCALA", 
      "90250" : "TLAXCO", 
      "90480" : "TOCATLAN", 
      "90160" : "TOTOLAC", 
      "90490" : "TZOMPANTEPEC", 
      "90460" : "XALOZTOC", 
      "90440" : "XALTOCAN", 
      "90780" : "XICOTZINGO", 
      "90450" : "YAUHQUEMEHCAN", 
      "90590" : "Z DE TRINIDAD SANCHEZ SANTOS", 
      "90740" : "ZACATELCO", 
    }, 
    "TM" : {
      "87760" : "ABASOLO", 
      "89670" : "ALDAMA", 
      "89600" : "ALTAMIRA", 
      "89960" : "ANTIGUO MORELOS", 
      "88890" : "BURGOS", 
      "87960" : "BUSTAMANTE", 
      "88440" : "CAMARGO", 
      "87250" : "CASAS", 
      "89400" : "CIUDAD MADERO", 
      "87640" : "CRUILLAS", 
      "89800" : "EL MANTE", 
      "89780" : "GOMEZ FARIAS", 
      "89700" : "GONZALEZ", 
      "87230" : "GUEMEZ", 
      "88370" : "GUERRERO", 
      "88400" : "GUSTAVO DIAZ ORDAZ", 
      "87800" : "HIDALGO", 
      "87930" : "JAUMAVE", 
      "87700" : "JIMENEZ", 
      "87200" : "LLERA", 
      "87860" : "MAINERO", 
      "87300" : "MATAMOROS", 
      "88880" : "MENDEZ", 
      "88390" : "MIER", 
      "88300" : "MIGUEL ALEMAN", 
      "87950" : "MIQUIHUANA", 
      "88000" : "NUEVO LAREDO", 
      "89970" : "NUEVO MORELOS", 
      "87980" : "OCAMPO", 
      "87780" : "PADILLA", 
      "87970" : "PALMILLAS", 
      "88500" : "REYNOSA", 
      "88800" : "RIO BRAVO", 
      "87730" : "SAN CARLOS", 
      "87600" : "SAN FERNANDO", 
      "87660" : "SAN NICOLAS", 
      "87670" : "SOTO LA MARINA", 
      "89000" : "TAMPICO", 
      "87900" : "TULA", 
      "87500" : "VALLE HERMOSO", 
      "87000" : "VICTORIA", 
      "87880" : "VILLAGRAN", 
      "89750" : "XICOTENCATL", 
    }, 
    "VE" : {
      "91320" : "ACAJETE", 
      "91420" : "ACATLAN", 
      "96000" : "ACAYUCAN", 
      "91480" : "ACTOPAN", 
      "95440" : "ACULA", 
      "94760" : "ACULTZINGO", 
      "96390" : "AGUA DULCE", 
      "94130" : "ALPATLAHUAC", 
      "91460" : "ALTO LUCERO", 
      "93700" : "ALTOTONGA", 
      "95250" : "ALVARADO", 
      "95450" : "AMATITLAN", 
      "94940" : "AMATLAN DE LOS REYES", 
      "92300" : "AMATLAN TUXPAN", 
      "95840" : "ANGEL R CABADA", 
      "91645" : "APAZAPAN", 
      "94750" : "AQUILA", 
      "94810" : "ASTACINGA", 
      "94830" : "ATLAHUILCO", 
      "94960" : "ATOYAC", 
      "94440" : "ATZACAN", 
      "93680" : "ATZALAN", 
      "91260" : "AYAHUALULCO", 
      "91300" : "BANDERILLA", 
      "92660" : "BENITO JUAREZ", 
      "94290" : "BOCA DEL RIO", 
      "94120" : "CALCAHUALCO", 
      "94230" : "CAMARON DE TEJEDA", 
      "94740" : "CAMERINO Z MENDOZA", 
      "94980" : "CARRILLO PUERTO", 
      "92940" : "CASTILLO DE TEAYO", 
      "95870" : "CATEMACO", 
      "92970" : "CAZONES DE HERRERA", 
      "92500" : "CERRO AZUL", 
      "95560" : "CHACALTIANGUIS", 
      "92170" : "CHALMA", 
      "92150" : "CHICONAMEL", 
      "93880" : "CHICONQUIACO", 
      "92700" : "CHICONTEPEC", 
      "95980" : "CHINAMECA", 
      "92420" : "CHINAMPA DE GOROSTIZA", 
      "94160" : "CHOCAMAN", 
      "92200" : "CHONTLA", 
      "93040" : "CHUMATLAN", 
      "92230" : "CITLALTEPETL", 
      "91370" : "COACOATZINTLA", 
      "93120" : "COAHUITLAN", 
      "91500" : "COATEPEC", 
      "92975" : "COATZACOALCOS", 
      "93160" : "COATZINTLA", 
      "94890" : "COETZALA", 
      "93950" : "COLIPA", 
      "94200" : "COMAPA", 
      "94480" : "CORDOBA", 
      "95330" : "COSAMALOAPAN", 
      "91620" : "COSAUTLAN DE CARVAJAL", 
      "94140" : "COSCOMATEPEC", 
      "96340" : "COSOLEACAQUE", 
      "94990" : "COTAXTLA", 
      "93060" : "COXQUIHUI", 
      "93140" : "COYUTLA", 
      "94920" : "CUICHAPA", 
      "94910" : "CUITLAHUAC", 
      "92400" : "EL HIGO", 
      "91630" : "EMILIANO ZAPATA", 
      "93180" : "ESPINAL", 
      "93100" : "FILOMENO MATA", 
      "94470" : "FORTIN", 
      "93550" : "GUTIERREZ ZAMORA", 
      "96930" : "HIDALGOTITLAN", 
      "94100" : "HUATUSCO", 
      "92600" : "HUAYACOCOTLA", 
      "95850" : "HUEYAPAN DE OCAMPO", 
      "94780" : "HUILOAPAN DE CUAUHTEMOC", 
      "95240" : "IGNACIO DE LA LLAVE", 
      "92620" : "ILAMATLAN", 
      "95640" : "ISLA", 
      "92270" : "IXCATEPEC", 
      "91250" : "IXHUACAN DE LOS REYES", 
      "92680" : "IXHUATLAN DE MADERO", 
      "94180" : "IXHUATLAN DEL CAFE", 
      "96365" : "IXHUATLAN DEL SURESTE", 
      "94430" : "IXHUATLANCILLO", 
      "95430" : "IXMATLAHUACAN", 
      "94450" : "IXTACZOQUITLAN", 
      "93660" : "JALACINGO", 
      "94000" : "JALCOMULCO", 
      "96200" : "JALTIPAN", 
      "94260" : "JAMAPA", 
      "96950" : "JESUS CARRANZA", 
      "91380" : "JILOTEPEC", 
      "95580" : "JOSE AZUETA", 
      "95670" : "JUAN RODRIGUEZ CLARA", 
      "91440" : "JUCHIQUE DE FERRER", 
      "91680" : "LA ANTIGUA", 
      "94150" : "LA PERLA", 
      "93860" : "LANDERO Y COSS", 
      "96980" : "LAS CHOAPAS", 
      "93740" : "LAS MINAS", 
      "91330" : "LAS VIGAS DE RAMIREZ", 
      "95280" : "LERDO DE TEJADA", 
      "95060" : "LOS REYES", 
      "94870" : "MAGDALENA", 
      "94700" : "MALTRATA", 
      "94250" : "MANLIO FABIO ALTAMIRANO", 
      "94420" : "MARIANO ESCOBEDO", 
      "93600" : "MARTINEZ DE LA TORRE", 
      "93080" : "MECATLAN", 
      "95930" : "MECAYAPAN", 
      "94270" : "MEDELLIN", 
      "91410" : "MIAHUATLAN", 
      "96700" : "MINATITLAN", 
      "93820" : "MISANTLA", 
      "95040" : "MIXTLA DE ALTAMIRANO", 
      "96370" : "MOLOACAN", 
      "96360" : "NANCHITAL DE LAZ.CARD. DEL RIO", 
      "91400" : "NAOLINCO", 
      "94880" : "NARANJAL", 
      "93800" : "NAUTLA", 
      "94720" : "NOGALES", 
      "96160" : "OLUTA", 
      "94900" : "OMEALCA", 
      "94300" : "ORIZABA", 
      "95500" : "OTATITLAN", 
      "96330" : "OTEAPAN", 
      "92080" : "OZULUAMA", 
      "95960" : "PAJAPAN", 
      "92000" : "PANUCO", 
      "93400" : "PAPANTLA", 
      "91670" : "PASO DE OVEJAS", 
      "94970" : "PASO DEL MACHO", 
      "91270" : "PEROTE", 
      "92130" : "PLATON SANCHEZ", 
      "95600" : "PLAYA VICENTE", 
      "93200" : "POZA RICA DE HIDALGO", 
      "92030" : "PUEBLO VIEJO", 
      "91650" : "PUENTE NACIONAL", 
      "94410" : "RAFAEL DELGADO", 
      "91315" : "RAFAEL LUCIO", 
      "94730" : "RIO BLANCO", 
      "95480" : "SALTABARRANCA", 
      "94850" : "SAN ANDRES TENEJAPAN", 
      "95700" : "SAN ANDRES TUXTLA", 
      "96120" : "SAN JUAN EVANGELISTA", 
      "95830" : "SANTIAGO TUXTLA", 
      "96150" : "SAYULA DE ALEMAN", 
      "94060" : "SOCHIAPA", 
      "96170" : "SOCONUSCO", 
      "94770" : "SOLEDAD ATZOMPA", 
      "94240" : "SOLEDAD DE DOBLADO", 
      "95900" : "SOTEAPAN", 
      "92470" : "TAMALIN", 
      "92560" : "TAMIAHUA", 
      "92040" : "TAMPICO ALTO", 
      "92540" : "TANCOCO", 
      "92430" : "TANTIMA", 
      "92100" : "TANTOYUCA", 
      "93760" : "TATATILA", 
      "93570" : "TECOLUTLA", 
      "95030" : "TEHUIPANGO", 
      "92730" : "TEMAPACHE", 
      "92060" : "TEMPOAL", 
      "94030" : "TENAMPA", 
      "93780" : "TENOCHTITLAN", 
      "91615" : "TEOCELO", 
      "94190" : "TEPATLAXCO", 
      "91430" : "TEPETLAN", 
      "92530" : "TEPETZINTLA", 
      "94840" : "TEQUILA", 
      "92640" : "TEXCATEPEC", 
      "95070" : "TEXHUACAN", 
      "96180" : "TEXISTEPEC", 
      "95081" : "TEZONAPA", 
      "95100" : "TIERRA BLANCA", 
      "92900" : "TIHUATLAN", 
      "92670" : "TLACHICHILCO", 
      "95520" : "TLACOJALPAN", 
      "91350" : "TLACOLULAN", 
      "95460" : "TLACOTALPAN", 
      "94080" : "TLACOTEPEC DE MEJIA", 
      "95220" : "TLALIXCOYAN", 
      "91230" : "TLALNELHUAYOCAN", 
      "94020" : "TLALTETELA", 
      "93650" : "TLAPACOYAN", 
      "94800" : "TLAQUILPAN", 
      "94860" : "TLILAPAN", 
      "94170" : "TOMATLAN", 
      "91360" : "TONAYAN", 
      "94050" : "TOTUTLA", 
      "95300" : "TRES VALLES", 
      "92770" : "TUXPAM", 
      "95540" : "TUXTILLA", 
      "91660" : "URSULO GALVAN", 
      "93960" : "VEGA DE ALATORRE", 
      "91294" : "VERACRUZ", 
      "91340" : "VILLA ALDAMA", 
      "93900" : "VILLA YECUATLA", 
      "91000" : "XALAPA", 
      "91240" : "XICO", 
      "94820" : "XOXOCOTLA", 
      "94930" : "YANGA", 
      "92650" : "ZACUALPAN", 
      "96320" : "ZARAGOZA", 
      "94220" : "ZENTLA", 
      "95000" : "ZONGOLICA", 
      "92630" : "ZONTECOMATLAN", 
      "93000" : "ZOZOCOLCO DE HIDALGO", 
    }, 
    "YU" : {
      "97825" : "ABALA", 
      "97380" : "ACANCEH", 
      "97990" : "AKIL", 
      "97450" : "BACA", 
      "97466" : "BOKOBA", 
      "97620" : "BUCTZOTZ", 
      "97460" : "CACALCHEN", 
      "97745" : "CALOTMUL", 
      "97410" : "CANSAHCAB", 
      "97915" : "CANTAMAYEC", 
      "97367" : "CELESTUN", 
      "97640" : "CENOTILLO", 
      "97955" : "CHACSINKIN", 
      "97758" : "CHANKOM", 
      "97857" : "CHAPAB", 
      "97770" : "CHEMAX", 
      "97760" : "CHICHIMILA", 
      "97940" : "CHIKINDZONOT", 
      "97816" : "CHOCHOLA", 
      "97904" : "CHUMAYEL", 
      "97345" : "CONKAL", 
      "97766" : "CUNCUNUL", 
      "97577" : "CUZAMA", 
      "97854" : "DZAN", 
      "97404" : "DZEMUL", 
      "97500" : "DZIDZANTUN", 
      "97606" : "DZILAM DE BRAVO", 
      "97600" : "DZILAM GONZALEZ", 
      "97660" : "DZITAS", 
      "97646" : "DZONCAUICH", 
      "97730" : "ESPITA", 
      "97830" : "HALACHO", 
      "97560" : "HOCABA", 
      "97480" : "HOCTUN", 
      "97580" : "HOMUN", 
      "97590" : "HUHI", 
      "97350" : "HUNUCMA", 
      "97343" : "IXIL", 
      "97540" : "IZAMAL", 
      "97370" : "KANASIN", 
      "97670" : "KANTUNIL", 
      "97764" : "KAUA", 
      "97360" : "KINCHIL", 
      "97818" : "KOPOMA", 
      "97900" : "MAMA", 
      "97850" : "MANI", 
      "97800" : "MAXCANU", 
      "97908" : "MAYAPAN", 
      "97000" : "MERIDA", 
      "97454" : "MOCOCHA", 
      "97430" : "MOTUL", 
      "97840" : "MUNA", 
      "97457" : "MUXUPIP", 
      "97813" : "OPICHEN", 
      "97880" : "OXKUTZCAB", 
      "97610" : "PANABA", 
      "97930" : "PETO", 
      "97320" : "PROGRESO", 
      "97655" : "QUINTANA ROO", 
      "97720" : "RIO LAGARTOS", 
      "97845" : "SACALUM", 
      "97810" : "SAMAHIL", 
      "97616" : "SAN FELIPE", 
      "97587" : "SANAHCAT", 
      "97890" : "SANTA ELENA", 
      "97570" : "SEYE", 
      "97420" : "SINANCHE", 
      "97690" : "SOTUTA", 
      "97630" : "SUCILA", 
      "97676" : "SUDZAL", 
      "97527" : "SUMA", 
      "97945" : "TAHDZIU", 
      "97490" : "TAHMEK", 
      "97910" : "TEABO", 
      "97820" : "TECOH", 
      "97535" : "TEKAL DE VENEGAS", 
      "97520" : "TEKANTO", 
      "97970" : "TEKAX", 
      "97680" : "TEKIT", 
      "97768" : "TEKOM", 
      "97400" : "TELCHAC PUEBLO", 
      "97407" : "TELCHAC PUERTO", 
      "97510" : "TEMAX", 
      "97740" : "TEMOZON", 
      "97530" : "TEPAKAN", 
      "97364" : "TETIZ", 
      "97524" : "TEYA", 
      "97860" : "TICUL", 
      "97377" : "TIMUCUY", 
      "97750" : "TINUM", 
      "97762" : "TIXCACALCUPUL", 
      "97470" : "TIXKOKOB", 
      "97950" : "TIXMEHUAC", 
      "97386" : "TIXPEHUAL", 
      "97700" : "TIZIMIN", 
      "97650" : "TUNKAS", 
      "97960" : "TZUCACAB", 
      "97796" : "UAYMA", 
      "97357" : "UCU", 
      "97390" : "UMAN", 
      "97780" : "VALLADOLID", 
      "97566" : "XOCCHEL", 
      "97920" : "YAXCABA", 
      "97348" : "YAXKUKUL", 
      "97425" : "YOBAIN", 
    }, 
    "ZA" : {
      "99940" : "APOZOL", 
      "99920" : "APULCO", 
      "99730" : "ATOLINGA", 
      "99780" : "BENITO JUAREZ", 
      "98500" : "CALERA", 
      "98480" : "CANITAS DE FELIPE PESCADOR", 
      "99260" : "CHALCHIHUITES", 
      "98200" : "CONCEPCION DEL ORO", 
      "98680" : "CUAUHTEMOC", 
      "98290" : "EL SALVADOR", 
      "98350" : "FRANCISCO R MURGUIA", 
      "99000" : "FRESNILLO", 
      "98660" : "GENARO CODINA", 
      "98560" : "GENERAL ENRIQUE ESTRADA", 
      "99590" : "GENERAL JOAQUIN AMARO", 
      "98730" : "GENERAL PANFILO NATERA", 
      "98600" : "GUADALUPE", 
      "99670" : "HUANUSCO", 
      "99600" : "JALPA", 
      "99300" : "JEREZ", 
      "99280" : "JIMENEZ DEL TEUL", 
      "98300" : "JUAN ALDAMA", 
      "99960" : "JUCHIPILA", 
      "98800" : "LORETO", 
      "98770" : "LUIS MOYA", 
      "98230" : "MAZAPIL", 
      "98220" : "MELCHOR OCAMPO", 
      "99860" : "MEZQUITAL DEL ORO", 
      "98330" : "MIGUEL AUZA", 
      "99720" : "MOMAX", 
      "99400" : "MONTE ESCOBEDO", 
      "98100" : "MORELOS", 
      "99980" : "MOYAHUA DE ESTRADA", 
      "99900" : "NOCHISTLAN DE MEJIA", 
      "98880" : "NORIA DE ANGELES", 
      "98700" : "OJOCALIENTE", 
      "98540" : "PANUCO", 
      "98920" : "PINOS", 
      "98400" : "RIO GRANDE", 
      "99130" : "SAIN ALTO", 
      "99100" : "SOMBRERETE", 
      "99480" : "SUSTICACAN", 
      "99630" : "TABASCO", 
      "99750" : "TEPECHITLAN", 
      "99570" : "TEPETONGO", 
      "99800" : "TEUL DE GONZALEZ ORTEGA", 
      "99700" : "TLALTENANGO DE SANCH.ROMAN", 
      "99830" : "TRINIDAD GARCIA DE LA CADENA", 
      "99200" : "VALPARAISO", 
      "98140" : "VETAGRANDE", 
      "98430" : "VILLA DE COS", 
      "98900" : "VILLA GARCIA", 
      "98840" : "VILLA GONZALEZ ORTEGA", 
      "98980" : "VILLA HIDALGO", 
      "99500" : "VILLANUEVA", 
      "98000" : "ZACATECAS", 
    }, 
  };
    const cities = $data[$state_code] ? $data[$state_code] : null;
    Object.keys(cities).map((citie) => {
        temporalCities = [
            ...temporalCities,
            {
                name: cities[citie],
                code: citie,
            },
        ];
    });
    return temporalCities;
}